import type { Messages } from './en-US';

/**
 * Bahasa Indonesia translation bundle. Typed as {@link Messages} so any key
 * added in `en-US.ts` becomes a compile-time error here until translated.
 */
export const idMessages: Messages = {
  common: {
    languageUpdateFailed: 'Gagal memperbarui bahasa',
    unknownPatient: 'Pasien Tidak Dikenal',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    somethingWentWrong: 'Terjadi kesalahan. Silakan coba lagi.',
    copyToClipboard: 'Salin ke clipboard',
    copyWithText: 'Salin: {text}',
    copied: 'Tersalin!',
    newSession: 'Sesi Baru',
  },
  widgetHeader: {
    settings: 'Pengaturan',
    accountSettings: 'Pengaturan Akun',
    customizeInsights: 'Kustomisasi Insight',
    helpAndFeedback: 'Bantuan & Saran',
    openInEluve: 'Buka di Eluve',
    hide: 'Minimalkan',
    testSentry: 'Test Sentry',
    language: 'Bahasa',
  },
  thumbs: {
    signedOut: 'Belum masuk',
    signIn: 'Masuk',
    welcome: 'Selamat datang',
    ready: 'Siap merekam',
    recording: 'Sedang merekam',
    paused: 'Dijeda',
    writingNote: 'Membuat catatan…',
    noteReady: 'Catatan siap',
    completed: 'Selesai',
    microphoneRequired: 'Mikrofon diperlukan',
    microphoneDisconnected: 'Mikrofon tidak tersambung',
    recordingTooShort: 'Rekaman terlalu singkat',
    notEnoughInfo: 'Informasi tidak cukup',
    somethingWentWrong: 'Terjadi kesalahan',
    summaryFailed: 'Ringkasan gagal',
    startRecording: 'Mulai merekam',
    finish: 'Selesaikan',
    pause: 'Jeda',
    recordMore: 'Lanjut rekaman',
    sendToEmr: 'Kirim ke EMR',
    sendToEmrAgain: 'Kirim ke EMR lagi',
    allowAccess: 'Izinkan akses',
    showDetails: 'Maksimalkan',
    microphone: 'Mikrofon',
    settings: 'Pengaturan janji temu',
    seeNotesTab: 'Lihat tab Catatan untuk detail',
    canceled: 'Janji temu dibatalkan',
  },
  appointment: {
    noSummaryAvailableTitle: 'Belum ada ringkasan',
    noSummaryAvailableDescription:
      'Catatan Anda akan dibuat di sini setelah sesi selesai.',
    insightsTab: 'Insight',
    notesTab: 'Catatan',
    transcriptTab: 'Transkrip',
    soapNotesTab: 'Catatan SOAP',
    noMicrophoneSelected: 'Tidak ada mikrofon yang dipilih',
    recordingTooShortTitle: 'Rekaman terlalu pendek',
    recordingTooShortBody:
      'Diperlukan minimal 10 detik audio untuk membuat catatan. Lanjutkan merekam, lalu coba lagi.',
    transcript: {
      empty: 'Tidak ada transkrip.',
      viewTranscript: 'Lihat Transkrip',
      hideTranscript: 'Sembunyikan Transkrip',
      sessionStartedAt: 'Sesi dimulai {date} pada {time}',
      sessionResumedAt: 'Sesi dilanjutkan {date} pada {time}',
      sessionPausedAt: 'Sesi dijeda {date} pada {time}',
    },
    transition: {
      title: 'Anda memiliki sesi yang sedang berlangsung untuk janji temu lain',
      description: 'Akhiri sesi saat ini agar dapat melanjutkan.',
      endSession: 'Akhiri Sesi',
      sessionPausedToast: 'Sesi Anda telah dijeda',
      sessionPausedToastDescription:
        'Kembali ke janji temu {patientName} untuk melanjutkan atau membuat catatan.',
    },
    presence: {
      title: 'Apakah Anda masih di sini?',
      description:
        'Sesi ini lebih lama dari biasanya. Akan dijeda otomatis dalam',
      pauseNow: 'Jeda Sekarang',
      continueRecording: 'Lanjutkan Merekam',
    },
    onboarding: {
      title: 'Siap merekam janji temu pertama Anda di Eluve?',
      subtitle:
        'Ceritakan sedikit tentang diri Anda agar kami dapat mempersonalisasi pengalaman Anda.',
      uiLanguageLabel: 'Bahasa apa yang Anda inginkan untuk Eluve?',
      uiLanguageTooltip:
        'Anda dapat mengubah ini kapan saja dari menu pengaturan di header.',
      uiLanguageAriaLabel: 'Bahasa Tampilan',
      uiLanguageSearchPlaceholder: 'Cari bahasa...',
      specialtyLabel: 'Apa spesialisasi Anda?',
      specialtyTooltip:
        'Ini membantu kami menyesuaikan templat catatan dan terminologi dengan area praktik Anda.',
      specialtyPlaceholder: 'Pilih spesialisasi...',
      inputLanguageLabel: 'Dalam bahasa apa Anda berbicara dengan pasien Anda?',
      inputLanguageTooltip:
        'Ini membantu meningkatkan akurasi transkripsi dengan mengoptimalkan bahasa percakapan Anda.',
      inputLanguageAriaLabel: 'Bahasa Percakapan',
      outputLanguageLabel: 'Dalam bahasa apa Anda menulis catatan SOAP?',
      outputLanguageAriaLabel: 'Bahasa Catatan',
      save: 'Simpan',
      saveFailed: 'Gagal menyimpan preferensi. Silakan coba lagi.',
    },
    audioFile: {
      unsupportedFormat:
        'Format tidak didukung: .{extension}. Gunakan {formats}.',
      tooLarge: 'File terlalu besar ({size}MB). Maks 100MB.',
      uploaded: 'File audio diunggah. Pemrosesan akan segera dimulai.',
      processFailed: 'Gagal memproses file audio.',
      processing: 'Memproses...',
      dropHere: 'Lepaskan file audio untuk diproses',
    },
    session: {
      unavailableTitle: 'Sesi Tidak Tersedia',
      unavailableDescription:
        'Sesi Anda tidak dapat dimuat. Klik Coba Lagi untuk memulihkannya.',
      retry: 'Coba Lagi',
    },
    languageSelector: {
      regenerateFailed: 'Gagal membuat ulang ringkasan. Silakan coba lagi.',
      regeneratingToast:
        'Sedang membuat ulang ringkasan Anda dalam bahasa baru',
      regeneratingToastDescription: 'Ringkasan baru Anda akan segera tersedia',
      spokenLanguageWarning:
        'Mengubah bahasa percakapan akan mentranskripsi ulang seluruh percakapan dari awal sesi.',
      notesLanguageWarning: 'Mengubah bahasa catatan akan membuat catatan baru',
      notesLanguageWarningDescription:
        'Catatan baru akan dibuat dalam {language}.',
      notesLanguageWarningOverwrite: 'Ini akan menimpa ringkasan saat ini.',
      theSelectedLanguage: 'bahasa yang dipilih',
      spokenLanguageLabel: 'Bahasa Percakapan:',
      spokenLanguageAriaLabel: 'Bahasa Percakapan',
      notesLanguageLabel: 'Bahasa Catatan:',
      notesLanguageAriaLabel: 'Bahasa Catatan',
    },
    signedSummary: {
      amendmentFailed: 'Gagal membuat amandemen',
      additionalNotes: 'Catatan Tambahan',
    },
    summarization: {
      noSummaryAvailable:
        'Tidak ada ringkasan yang tersedia untuk janji temu ini',
    },
    summaryFailed: {
      regenerateNote: 'Coba lagi',
    },
    insights: {
      differentialDiagnoses: 'Diagnosis Diferensial',
      generate: 'Buat',
      generateBlockedTooltip:
        'Pre-Visit Insights hanya dibuat untuk janji temu mendatang atau yang sedang berlangsung.',
      blockedTitle: 'Pre-Visit Insights tidak tersedia',
      blockedMessage:
        'Janji temu ini tidak lagi mendatang, sehingga Pre-Visit Insights baru tidak dibuat.',
      title: 'Insight AI',
      tooltip:
        'Insight yang dihasilkan AI berdasarkan riwayat pasien untuk membantu menginformasikan keputusan klinis Anda.',
      collapse: 'Tutup',
      show: 'Tampilkan',
      loading: {
        reviewingPriorNotes: 'Meninjau catatan pasien sebelumnya…',
        summarizingDocumentation: 'Meringkas dokumentasi…',
        gatheringInsights: 'Mengumpulkan insight…',
      },
      pvi: {
        noDataTitle: 'Tidak ada catatan sebelumnya untuk pasien ini',
        noDataMessage:
          'Eluve tidak memiliki data sebelumnya tentang pasien ini. Mulai merekam janji temu Anda untuk membuat catatan pertama untuk pasien ini.',
        errorTitle: 'Tidak dapat membuat insight AI',
        errorMessage:
          'Eluve tidak dapat membuat insight untuk pasien ini. Anda masih dapat merekam dan meringkas janji temu Anda.',
      },
    },
    ddx: {
      couldNotGenerate: 'Tidak dapat membuat DDx',
      couldNotGenerateDescription:
        'Eluve tidak dapat membuat diagnosis diferensial untuk janji temu ini.',
      notGenerated:
        'Belum ada diagnosis yang tersedia. Silakan periksa kembali setelah merekam dan meringkas janji temu Anda.',
      empty: 'Tidak ada diagnosis diferensial yang teridentifikasi.',
      considerations: 'PERTIMBANGAN',
      feedbackPrompt: 'Apakah diagnosis ini membantu?',
      loading: {
        analyzing: 'Menganalisis konteks klinis…',
        identifying: 'Mengidentifikasi diagnosis diferensial…',
        evaluating: 'Mengevaluasi bukti diagnostik…',
      },
    },
    feedback: {
      yes: 'Ya',
      no: 'Tidak',
      additionalFeedback: 'Ada masukan tambahan?',
      ratingPrompt: 'Bagaimana pengalaman Eluve Anda di sesi ini?',
      ratingPoor: 'Buruk',
      ratingOkay: 'Cukup',
      ratingExcellent: 'Sangat Baik',
      tellMore: 'Ceritakan lebih lanjut!',
      submit: 'Kirim Masukan',
      wasNoteHelpful: 'Apakah catatan ini membantu?',
      summarySaveFailed: 'Gagal menyimpan masukan',
      summaryUpdateFailed: 'Gagal memperbarui masukan',
      summaryTagsUpdateFailed: 'Gagal memperbarui tag masukan',
      thanksPositive: 'Terima kasih atas masukannya! Senang Anda menyukainya!',
      thanksNegative:
        'Maaf jika ringkasan ini kurang memuaskan. Setiap masukan yang Anda berikan (positif atau negatif) membantu kami meningkatkan hasil di masa depan.',
      wasHelpful: 'Apakah ini membantu?',
      shareFeedback: 'Bagikan masukan',
      commentsOptional: 'KOMENTAR (OPSIONAL)',
      tellMoreOptional: 'Ceritakan lebih lanjut (opsional)',
      submitShort: 'Kirim',
      closeForm: 'Tutup formulir masukan',
      thumbsUp: 'Suka',
      thumbsDown: 'Tidak suka',
      tagTooLong: 'Terlalu panjang',
      tagWrongInformation: 'Informasi salah',
      tagTooSlow: 'Terlalu lambat',
      tagNotEnoughInformation: 'Informasi tidak cukup',
      tagOtherIssue: 'Masalah lain',
      tagMissingDetails: 'Detail penting hilang',
      tagIrrelevantDetails: 'Detail tidak relevan',
      tagUnspokenDetails: 'Mengandung informasi fiktif',
      tagIncorrectNumber: 'Kesalahan angka',
      tagIncorrectBodyPart: 'Kesalahan bagian tubuh',
      tagBadFormatting: 'Format tidak rapi',
      tagTooVerbose: 'Terlalu panjang',
    },
    summary: {
      copiedToClipboard: 'Ringkasan disalin ke clipboard',
      copySummary: 'Salin Ringkasan',
    },
    syncEhr: {
      syncFailed: 'Sinkronisasi Gagal',
      syncedSuccessfully: 'Berhasil Disinkronkan!',
      notAvailableLocation:
        'Sinkronisasi catatan tidak tersedia untuk lokasi Anda.',
      notOwner:
        'Hanya pemilik janji temu yang dapat menyinkronkan catatan ini.',
      chartNotModified:
        'Chart belum diubah. Silakan isi chart sebelum menyinkronkan catatan.',
      selectPatient: 'Pilih pasien sebelum menyinkronkan catatan.',
      selectLocation: 'Pilih lokasi sebelum menyinkronkan catatan.',
      notAvailableNow: 'Sinkronisasi catatan tidak tersedia saat ini.',
      pushToEmr: 'Kirim ke EMR',
      pushAgainNotAvailable:
        'Catatan ini sudah dikirim ke EHR Anda dan tidak dapat dikirim ulang.',
      syncAgain: 'Sinkron Ulang',
    },
    settings: {
      spokenLanguageDescription:
        'Mengubah bahasa percakapan akan mentranskripsi ulang seluruh percakapan dari awal sesi.',
      retranscribeSession: 'Transkripsi Ulang Sesi',
      notesLanguageDescription:
        'Ini akan membuat ulang catatan dalam bahasa yang dipilih dan menimpa yang ada.',
      regenerateNote: 'Buat Ulang Catatan',
      templateDescription:
        'Ini akan membuat ulang catatan menggunakan templat yang dipilih dan menimpa yang ada.',
      filterPlaceholder: 'Ketik untuk memfilter...',
      noLanguagesFound: 'Tidak ada bahasa ditemukan.',
      noTemplatesFound: 'Tidak ada templat ditemukan.',
      templateUpdateFailed: 'Templat tidak dapat diperbarui.',
      spokenLanguageUpdateFailed: 'Bahasa percakapan tidak dapat diperbarui.',
      noteLanguageUpdateFailed: 'Bahasa catatan tidak dapat diperbarui.',
      spokenLanguageItem: 'Bahasa percakapan: {language}',
      noteLanguageItem: 'Bahasa catatan: {language}',
      templateItem: 'Templat: {template}',
      notSelected: 'Tidak dipilih',
      testSentry: 'Test Sentry',
      spokenLanguageHeading: 'Bahasa percakapan',
      noteLanguageHeading: 'Bahasa catatan',
      templateHeading: 'Templat',
      confirmTitle: 'Apakah Anda yakin?',
    },
    summaryStates: {
      pendingDataTitle: 'Menyiapkan pembuatan catatan...',
      pendingDataDescription:
        'Kami masih mengunggah dan memproses beberapa file. Setelah selesai, kami akan membuat catatan Anda.',
      inProgressTitle: 'Membuat catatan...',
      inProgressDescription:
        'Anda dapat meninggalkan halaman ini dan memulai sesi baru! Kami akan memberi tahu Anda saat catatan siap.',
      takingLongerTitle: 'Proses ini lebih lama dari biasanya...',
      takingLongerDescription:
        'Kami masih mengerjakan catatan Anda. Anda dapat meninggalkan halaman ini dan memulai sesi baru! Kami akan memberi tahu Anda saat siap.',
      regenerateHint:
        'Anda dapat mencoba membuat ulang catatan menggunakan templat yang berbeda.',
    },
    contentStates: {
      notFoundTitle: 'Janji temu tidak ditemukan',
      notFoundDescription:
        'Kami tidak dapat menemukan janji temu ini di EMR. Coba buka janji temu lain.',
      canceledTitle: 'Janji temu dibatalkan',
      canceledDescription:
        'Janji temu ini dibatalkan di EMR Anda. Coba buka janji temu lain.',
      notStartedTitle: 'Siap merekam',
      notStartedDescription: 'Tekan "Mulai merekam" untuk memulai.',
      recordingTitle: 'Sedang merekam',
      recordingDescription:
        'Bicaralah secara biasa. Jelaskan riwayat, gejala, dan penilaian klinis Anda.',
      pausedTitle: 'Perekaman dijeda',
      pausedDescription:
        'Tekan "Lanjut rekaman" untuk melanjutkan, atau "Selesaikan" untuk menulis catatan.',
      pendingAudioTitle: 'Mengunggah rekaman…',
      pendingAudioDescription: 'Hanya perlu beberapa saat.',
      summarizingTitle: 'Menulis catatan…',
      summarizingDescription:
        'Biasanya hanya perlu waktu kurang dari satu menit.',
      takingLongerTitle: 'Ini memakan waktu lebih lama dari biasanya…',
      takingLongerDescription:
        'Kami masih menulis catatan Anda. Anda dapat meninggalkan halaman ini. Kami akan memberi tahu saat sudah siap.',
      stuckTitle: 'Rekaman Anda tidak terkirim',
      stuckDescription: 'Pengunggahan terputus. Coba lagi.',
      degradedTranscriptTitle: 'Sebagian audio tidak dapat diproses',
      degradedTranscriptDescription: 'Coba lagi. Biasanya ini berhasil.',
      noteTooShortTitle: 'Rekaman terlalu pendek',
      noteTooShortDescription:
        'Kami hanya menangkap beberapa kata dari rekaman Anda. Untuk menulis catatan yang akurat, tekan "Lanjut rekaman" dan jelaskan detail klinis.',
      noteNoContextTitle: 'Detail klinis tidak cukup',
      noteNoContextDescription:
        'Untuk menulis catatan yang akurat, tekan "Lanjut rekaman" dan jelaskan detail klinis. Seperti gejala, diagnosis, atau rencana.',
      failedTitle: 'Terjadi kesalahan',
      failedDescription:
        'Tim teknisi kami sudah mengetahuinya dan sedang menanganinya. Silakan coba lagi.',
      templateFailedTitle: 'Templat ini tidak berhasil',
      templateFailedDescription:
        'Kami tidak dapat menulis catatan Anda. Pilih templat lain di bawah, lalu coba lagi.',
      micPermissionTitle: 'Akses mikrofon diperlukan',
      micPermissionDescription:
        'Eluve memerlukan mikrofon Anda untuk merekam audio.',
      micDisconnectTitle: 'Mikrofon terputus',
      micDisconnectDescription:
        'Perekaman dijeda. Pilih mikrofon, lalu tekan "Lanjut rekaman".',
      recordingErrorTitle: 'Perekaman terganggu',
      recordingErrorDescription: 'Coba lagi atau muat ulang halaman.',
      sessionExpiredTitle: 'Sesi berakhir',
      sessionExpiredDescription:
        'Rekaman Anda tersimpan. Muat ulang halaman untuk melanjutkan.',
      lowStorageTitle: 'Ruang penyimpanan perangkat Anda hampir habis',
      lowStorageDescription:
        'Kosongkan ruang di komputer Anda untuk terus merekam. Yang sudah terekam tetap tersimpan.',
      recordingErrorRefresh: 'Muat ulang',
      recordingErrorRetry: 'Coba lagi',
      recordingErrorDismiss: 'Tutup',
    },
    summarizationError: {
      somethingWrong: 'Terjadi kesalahan',
      failedToGenerate: 'Gagal membuat catatan',
      teamInvestigating:
        'Tim kami sedang menyelidiki masalah ini. Anda dapat mencoba lagi, atau kirim email ke support@eluve.com jika butuh bantuan.',
      recordingTooShort:
        'Rekaman ini terlalu pendek atau tidak memiliki cukup informasi klinis untuk membuat catatan. Lanjutkan merekam untuk menambah konten.',
      templateSelectionRequired:
        'Pembuatan catatan gagal. Pilih templat berbeda di bawah dan klik Buat Ulang untuk mencoba lagi.',
    },
    summaryStuck: {
      description:
        'Kami tidak dapat membuat catatan Anda. Anda dapat mencoba lagi, atau kirim email ke support@eluve.com jika butuh bantuan.',
      retryButton: 'Coba Lagi',
      retrySuccessTitle: 'Sedang mencoba lagi',
      retrySuccessDescription: 'Catatan Anda akan segera tersedia',
      retryErrorTitle: 'Gagal mencoba lagi',
      retryErrorDescription: 'Silakan coba lagi atau hubungi support',
    },
    regenerate: {
      button: 'Buat Ulang',
      title: 'Sedang membuat ulang ringkasan Anda',
      overwriteWarning: 'Ini akan menimpa ringkasan saat ini.',
      templateLabel: 'Catatan baru Anda akan dibuat dengan templat berikut:',
      successDescription: 'Ringkasan baru Anda akan segera tersedia',
      errorTitle: 'Gagal membuat ulang ringkasan',
      errorDescription: 'Silakan coba lagi',
    },
    disabledTooltips: {
      noMicTitle: 'Mikrofon Belum Dipilih',
      noAudioTitle: 'Audio Tidak Terdeteksi',
      noMicDescription: 'Silakan pilih salah satu untuk mulai merekam.',
      noAudioDescription:
        'Silakan nyalakan mikrofon Anda atau pilih yang lain untuk mulai merekam.',
      storageFullTitle: 'Penyimpanan tidak cukup',
      storageFullDescription:
        'Ruang penyimpanan perangkat Anda hampir habis sehingga rekaman bisa gagal tersimpan. Kosongkan ruang dan coba lagi.',
      recordingTooShortTitle: 'Rekaman terlalu singkat',
      recordingTooShortDescription:
        'Kami membutuhkan setidaknya 10 detik audio untuk menulis catatan. Silakan lanjutkan merekam.',
    },
    completed: {
      synced: 'Disinkronkan',
      syncedWithDate: 'Disinkronkan: {date}',
    },
    active: {
      pausedWithDuration: 'Dijeda - {duration}',
      pausedWithDurationDot: 'Dijeda · {duration}',
      pauseRecording: 'Jeda Rekaman',
      resumeRecording: 'Lanjutkan Merekam',
    },
  },
  summaryComparison: {
    triggerTitle: 'OUTPUT ALTERNATIF',
    triggerDescription: 'Lihat opsi alternatif dan pilih favorit Anda!',
    thankYouTitle: 'TERIMA KASIH',
    thankYouDescription: 'Ringkasan Anda telah diperbarui sesuai pilihan Anda.',
    selectionFailed: 'Gagal menyimpan pilihan Anda. Silakan coba lagi.',
    updateDefaultFailed:
      'Gagal memperbarui templat default Anda. Silakan coba lagi.',
    updateDefaultTitle: 'Perbarui templat default Anda?',
    updateDefaultDescription:
      'Catatan yang Anda pilih dibuat dengan templat yang berbeda dari default Anda saat ini. Ingin menjadikan templat ini sebagai default baru Anda?',
    updateDefaultConfirm: 'Perbarui default',
    dialogTitle: 'Catatan mana yang lebih Anda sukai?',
    dialogDescription:
      'Pilihan Anda membantu kami meningkatkan kualitas ringkasan di masa mendatang.',
    preferThisNote: 'Saya pilih catatan ini',
    generatedIn: 'Dibuat dalam {seconds} detik',
  },
  blocks: {
    transcriptionWarning: {
      title: 'Transkripsi langsung telah dijeda.',
      description:
        'Rekaman Anda tetap disimpan. Transkrip akan diselesaikan setelah janji temu selesai.',
    },
    language: {
      searchPlaceholder: 'Cari bahasa...',
    },
    specialty: {
      defaultPlaceholder: 'Pilih spesialisasi',
      other: 'Lainnya',
      clearSpecialty: 'Hapus spesialisasi',
      enterSpecialty: 'Masukkan spesialisasi Anda',
      searchPlaceholder: 'Cari spesialisasi...',
    },
    callout: {
      dismissTip: 'Tutup tip: {title}',
      dontShowAgain: 'Jangan tampilkan lagi',
    },
    showAllAppointments: 'Tampilkan semua janji temu',
    dateNavigator: {
      today: 'Hari ini',
    },
    settingsImageUpload: {
      upload: 'Unggah',
      uploadAria: 'Unggah {label}',
      deleteAria: 'Hapus {label}',
    },
  },
  chat: {
    header: {
      patientInsights: 'Insight Pasien',
      eluveInsights: 'Eluve Insights',
      newChat: 'Chat baru',
      pastChats: 'Riwayat chat',
      close: 'Tutup',
    },
    threads: {
      titlePlaceholder: 'Judul percakapan',
      unnamed: 'Percakapan Tanpa Nama',
      conversationAria: 'Percakapan: {title}',
      loadMore: 'Muat lebih banyak',
    },
    emptyState: {
      heading: 'Tanyakan apa saja kepada Eluve',
      more: 'Lebih banyak',
      less: 'Lebih sedikit',
      disclaimer:
        'AI dapat membuat kesalahan. Mohon periksa kembali jawabannya.',
      seeTermsPrefix: 'Lihat',
      termsLinkLabel: 'Syarat & Ketentuan',
      seeTermsSuffix: 'untuk info lebih lanjut.',
    },
    input: {
      placeholder: 'Tanyakan apa saja',
      attachFile: 'Lampirkan file',
      stop: 'Berhenti',
      send: 'Kirim pesan',
    },
    tools: {
      getPatientNotesActive: 'Mencari rekam medis pasien',
      getPatientNotesCompleted: 'Rekam medis pasien ditemukan',
      createSpecTemplateActive: 'Menyusun pratinjau template',
      createSpecTemplateCompleted: 'Template siap',
      saveSpecTemplateActive: 'Menyimpan template',
      saveSpecTemplateCompleted: 'Template disimpan',
      draftDocumentActive: 'Menyusun draf dokumen',
      draftDocumentCompleted: 'Draf dokumen siap',
      generateDocumentActive: 'Menyimpan dokumen',
      generateDocumentCompleted: 'Dokumen disimpan',
      getAppointmentNoteActive: 'Membaca catatan janji temu',
      getAppointmentNoteCompleted: 'Catatan janji temu dimuat',
      updateAppointmentNoteActive: 'Memperbarui catatan janji temu',
      updateAppointmentNoteCompleted: 'Catatan janji temu diperbarui',
      getCustomInstructionsActive: 'Membaca instruksi kustom',
      getCustomInstructionsCompleted: 'Instruksi kustom dimuat',
      suggestCustomInstructionActive: 'Menyiapkan saran',
      suggestCustomInstructionCompleted: 'Saran siap',
      saveCustomInstructionActive: 'Menyimpan instruksi kustom',
      saveCustomInstructionCompleted: 'Instruksi kustom disimpan',
      queryFhirResourcesActive: 'Mencari rekam klinis',
      queryFhirResourcesCompleted: 'Rekam klinis ditemukan',
      patientNotesAgentActive: 'Bertanya ke Agen Catatan Pasien',
      patientNotesAgentCompleted: 'Agen Catatan Pasien merespons',
      conversationStarterAgentActive: 'Bertanya ke Agen Pembuka Percakapan',
      conversationStarterAgentCompleted: 'Agen Pembuka Percakapan merespons',
      defaultActive: 'Sedang bekerja',
      defaultCompleted: 'Selesai',
      appointmentNote: 'Catatan janji temu',
    },
    document: {
      drafting: 'Menyusun draf dokumen…',
      saveFailed: 'Gagal menyimpan dokumen. Silakan coba lagi.',
      titlePlaceholder: 'Judul dokumen',
      add: 'Tambahkan Dokumen',
      copy: 'Salin',
      copied: 'Tersalin',
      discard: 'Buang',
      addedToNotes: 'Ditambahkan ke catatan',
      discarded: 'Dibuang',
      discardDialogTitle: 'Buang dokumen?',
      discardDialogDescription:
        'Ini akan membuang draf dokumen. Anda selalu dapat meminta chat untuk membuat yang baru.',
      discardMessage: 'Buang dokumen itu, saya tidak membutuhkannya.',
    },
    starters: {
      preparingSuggestion: 'Menyiapkan saran…',
      suggestedTitle: 'Saran Pembuka Percakapan',
      outputPreference: 'Preferensi Output (opsional)',
      none: 'Tidak ada',
      dismiss: 'Abaikan',
      dismissMessage: 'Tidak, jangan simpan itu sebagai pembuka percakapan.',
      confirmMessage: 'Ya, simpan itu sebagai pembuka percakapan.',
      confirmWithPreferenceMessage:
        'Ya, simpan itu sebagai pembuka percakapan dengan preferensi output "{label}".',
      save: 'Simpan Pembuka',
      saving: 'Menyimpan pembuka percakapan…',
      saved: 'Pembuka percakapan disimpan',
      starterAria: 'Pembuka percakapan: {title}',
    },
    instructions: {
      preparingSuggestion: 'Menyiapkan saran…',
      suggestedTitle: 'Saran Instruksi Kustom',
      dismiss: 'Abaikan',
      dismissMessage: 'Tidak, jangan simpan itu sebagai instruksi kustom.',
      confirmMessage: 'Ya, simpan itu sebagai instruksi kustom.',
      save: 'Simpan Instruksi',
    },
    feedback: {
      wasHelpful: 'Apakah respons ini membantu?',
      sendFailed: 'Gagal mengirim masukan',
      updateFailed: 'Gagal memperbarui masukan',
      commentFailed: 'Gagal menyimpan komentar',
      thanksPositive:
        'Terima kasih atas masukannya! Senang respons ini bermanfaat untuk Anda!',
      thanksNegative:
        'Maaf respons ini belum sesuai harapan. Setiap masukan membantu kami meningkatkan hasil di masa mendatang.',
    },
    citations: {
      sources: 'Sumber:',
      viewLess: 'Tampilkan Lebih Sedikit',
      viewAll: 'Tampilkan Semua ({count})',
    },
    pdf: {
      passwordProtectedTooltip:
        'PDF ini dilindungi kata sandi. Klik untuk membukanya!',
      previewTooltip: 'Pratinjau PDF ini',
      removeFile: 'Hapus {fileName}',
      passwordRequiredTitle: 'Kata Sandi Diperlukan',
      passwordRequired: 'Kata sandi wajib diisi',
      enterPasswordFor: 'Masukkan kata sandi untuk membuka {fileName}.',
      fileFallback: 'file',
      passwordPlaceholder: 'Masukkan kata sandi',
      invalidPassword: 'Kata sandi salah',
      unlockedSuccess: 'PDF berhasil dibuka',
      unlocking: 'Membuka...',
      unlock: 'Buka',
    },
    knowledgeSources: {
      updateFailed: 'Gagal memperbarui sumber pengetahuan',
      saveFileFailed: 'Gagal menyimpan file yang diunggah',
      removeFileFailed: 'Gagal menghapus file',
      downloadFailed: 'Gagal mengunduh file',
      uploadedFiles: 'File yang Diunggah',
      uploadFiles: 'Unggah file',
      noFiles: 'Belum ada file yang diunggah',
    },
    recentNotes: {
      label: 'Catatan terbaru',
      tooltip:
        'Chat mungkin tidak memiliki akses ke semua catatan. Chat membaca catatan terbaru pasien ini dari EMR Anda, serta catatan yang dibuat di Eluve.',
    },
  },
  errors: {
    homeScreenNotFound: {
      title: 'Beranda tidak tersedia',
      message:
        'Maaf, kami tidak dapat memuat beranda EHR Anda. Silakan muat ulang halaman dan coba lagi.',
    },
    notLoggedIn: {
      title: 'Tidak diizinkan',
      message: 'Silakan login ke akun EHR Anda di tab baru dan coba lagi.',
    },
    soapTemplateNotFound: {
      title: 'Templat tidak ditemukan',
      message:
        'Templat tidak ditemukan: "SOAP Template". Silakan periksa apakah templat tersebut ada dan coba lagi.',
    },
    noteEditorNotFound: {
      title: 'Editor catatan tidak tersedia',
      message:
        'Kami tidak dapat menemukan editor catatan di EHR. Pastikan editor tersedia dan coba lagi.',
    },
    templateNotSupported: {
      title: 'Templat tidak didukung',
      message:
        'Templat yang dipilih tidak didukung oleh EHR. Silakan pilih templat lain dan coba lagi.',
    },
    failedToSign: {
      title: 'Penandatanganan entri chart gagal',
      message:
        'Kami mengalami kendala saat menandatangani entri chart. Silakan coba lagi.',
    },
    genericError: {
      title: 'Terjadi kesalahan',
      message:
        'Tim kami sedang menyelidiki masalah ini. Anda dapat mencoba lagi, atau kirim email ke support@eluve.com jika butuh bantuan.',
    },
    timeout: {
      title: 'Permintaan habis waktu',
      message:
        'Proses permintaan Anda memakan waktu terlalu lama. Silakan periksa koneksi internet Anda dan coba lagi.',
    },
    failedToImport: {
      title: 'Impor gagal',
      message: 'Gagal mengimpor data. Silakan periksa data dan coba lagi.',
    },
    staffMismatch: {
      title: 'Pemilik janji temu tidak sesuai',
      message:
        'Pemilik janji temu tidak sesuai dengan pengguna saat ini di EHR. Pastikan Anda masuk sebagai pengguna yang benar dan coba lagi.',
    },
    invalidStatePageRefreshRequired: {
      title: 'Sesi berakhir',
      message:
        'Kami mendeteksi kondisi yang tidak konsisten. Silakan muat ulang halaman untuk melanjutkan.',
    },
    micDisconnected: {
      title: 'Mikrofon tidak terdeteksi',
      message:
        'Rekaman Anda telah dijeda. Silakan perbarui pilihan mikrofon untuk melanjutkan.',
    },
    micPermissionsDenied: {
      title: 'Akses mikrofon diperlukan',
      message:
        'Eluve memerlukan izin untuk mengakses mikrofon Anda agar dapat merekam audio.',
    },
    domInjectionFailed: {
      title: 'Tidak berhasil',
      message: 'Coba salin catatan per bagian.',
    },
    patientDeleted: {
      title: 'Pasien tidak ditemukan di EHR',
      message:
        'Pasien yang terkait dengan janji temu ini telah dihapus di EHR Anda. Pastikan pasien tersebut ada atau pilih pasien yang benar di Eluve, lalu coba lagi.',
    },
    appointmentNotFound: {
      title: 'Janji temu tidak ditemukan di EHR',
      message:
        'Janji temu mungkin telah dihapus atau dijadwalkan ulang di EHR Anda. Verifikasi keberadaan janji temu dan coba lagi.',
    },
    userIdMismatch: {
      title: 'Ketidaksesuaian pengguna terdeteksi',
      message:
        'Pengguna yang telah login tidak sesuai dengan pengguna EHR saat ini. Otentikasi ulang secara otomatis.',
    },
    extensionConnectionLost: {
      title: 'Koneksi ekstensi terputus',
      message:
        'Koneksi ke ekstensi Eluve terputus. Silakan muat ulang halaman dan coba lagi.',
    },
    insufficientStorage: {
      title: 'Perekaman dijeda karena ruang penyimpanan hampir habis',
      message:
        'Ruang penyimpanan perangkat Anda hampir habis. Kami menjeda perekaman untuk menyimpan yang sudah terekam. Kosongkan ruang untuk melanjutkan, atau selesaikan untuk membuat catatan.',
    },
    ehrIntegrationNotAvailable: {
      title: 'Integrasi EHR Tidak Tersedia',
      message:
        'Vendor EHR ini memerlukan integrasi ekstensi browser yang tidak tersedia di sini.',
    },
    appointmentAlreadySigned: {
      title: 'Catatan sudah ditandatangani',
      message:
        'Catatan untuk janji temu ini sudah ditandatangani, sehingga tidak dapat direkam atau dibuat ulang.',
    },
  },
  sidebar: {
    overview: 'Ikhtisar',
    appointments: 'Janji Temu',
    patients: 'Pasien',
    services: 'Layanan',
    careLibrary: 'Pustaka Perawatan',
    tasks: 'Tugas',
    settings: 'Pengaturan',
    support: 'Dukungan',
  },
  userMenu: {
    impersonatingUser: 'Menyamar sebagai Pengguna',
    exitImpersonation: 'Keluar dari Penyamaran',
    switchOrganization: 'Ganti Organisasi',
    unnamedOrganization: 'Organisasi Tanpa Nama',
    organizationSettings: 'Pengaturan Organisasi',
    betaFeatures: 'Fitur Beta',
    systemStatus: 'Status Sistem',
    contactUs: 'Hubungi Kami',
    logOut: 'Keluar',
    endRecordingToSwitchTitle: 'Akhiri rekaman untuk berganti?',
    endRecordingToSwitchDescription:
      'Anda memiliki rekaman yang sedang berlangsung. Berganti organisasi akan mengakhiri sesi rekaman saat ini.',
    keepRecording: 'Lanjutkan merekam',
    ending: 'Mengakhiri…',
    endAndSwitch: 'Akhiri & ganti',
  },
  settings: {
    nav: {
      backToApp: 'Kembali ke aplikasi',
      account: 'Akun',
      preferences: 'Preferensi',
      organization: 'Organisasi',
      userSettings: 'Pengaturan Pengguna',
      audioDisplay: 'Audio & Tampilan',
      shortcuts: 'Pintasan',
      appGrants: 'Izin Aplikasi',
      note: 'Catatan',
      tasks: 'Tugas',
      templates: 'Templat',
      chat: 'Chat',
      insights: 'Insight',
      general: 'Umum',
      members: 'Anggota',
      sessionTypes: 'Jenis Sesi',
      locations: 'Lokasi',
      services: 'Layanan',
      providers: 'Penyedia',
      userGroups: 'Grup Pengguna',
      noteRecovery: 'Pemulihan Catatan',
      carePlans: 'Rencana Perawatan',
    },
    common: {
      save: 'Simpan',
      add: 'Tambah',
      delete: 'Hapus',
      reset: 'Atur Ulang',
      examples: 'CONTOH',
      resetToDefaultTitle: 'Atur Ulang ke Pengaturan Default?',
    },
    user: {
      generalDescription: 'Informasi dasar profil dan akun Anda.',
      email: 'Email',
      fullName: 'Nama Lengkap',
      specialty: 'Spesialisasi',
      signature: 'Tanda Tangan',
      providerDetailsTitle: 'Detail Penyedia Layanan Medis',
      providerDetailsDescription:
        'Masukkan nomor lisensi, nomor NPI, dan detail relevan lainnya tentang praktik medis Anda.',
      baaTitle: 'Perjanjian Rekan Bisnis (BAA)',
      baaSafeguarding:
        'Kami peduli dengan perlindungan data Anda. BAA Anda adalah bagian dari kepatuhan terhadap HIPAA.',
      baaRequestPrefix:
        'Jika organisasi Anda memerlukan versi BAA yang ditandatangani secara terpisah untuk keperluan arsip, Anda dapat memintanya dengan mengirim email ke',
      viewBaa: 'Lihat BAA',
      downloadPdf: 'Unduh PDF',
    },
    audio: {
      microphone: 'Mikrofon',
      microphoneDescription:
        'Uji dan pilih input audio yang digunakan untuk rekaman.',
      notifications: 'Notifikasi',
      soundEffect: 'Efek Suara',
      soundEffectDescription:
        'Putar nada saat memulai atau menghentikan rekaman.',
      previewSound: 'Pratinjau Suara',
      play: 'Putar',
      language: 'Bahasa',
      interfaceLanguageLabel: 'Bahasa Antarmuka',
      interfaceLanguageDescription:
        'Bahasa pilihan Anda untuk antarmuka Eluve.',
      interfaceLanguageSearchPlaceholder: 'Cari bahasa...',
      privacyDisplay: 'Privasi & tampilan',
      privacyMode: 'Mode Privasi',
      privacyModeDescription: 'Sembunyikan informasi pasien dari layar Anda.',
      privacyModeToggleHintPrefix: 'Alihkan dari mana saja dengan',
      examplePatientName: 'Contoh nama pasien:',
      showAppointmentOwners: 'Tampilkan Pemilik Janji Temu',
      showAppointmentOwnersDescription:
        'Tampilkan pemilik setiap janji temu di agenda Anda.',
      shareScreenWithSupport: 'Bagikan layar dengan dukungan',
      shareScreenDescription:
        'Pantau interaksi untuk sementara guna keperluan debugging. Ini akan merekam interaksi Anda di produk Eluve hingga {hours} jam lalu mati secara otomatis. Rekaman ini akan disimpan hingga 30 hari di lingkungan yang mematuhi HIPAA dan kemudian dihapus secara otomatis.',
      micPreferencesChanged: 'Preferensi mikrofon diubah',
      micNotFound: 'Mikrofon tidak dapat ditemukan',
      stopTest: 'Berhenti',
      test: 'Uji',
    },
    note: {
      title: 'Preferensi Catatan',
      defaults: 'Default',
      defaultsDescription:
        'Preferensi umum yang diterapkan pada setiap catatan baru.',
      defaultTemplate: 'Templat Default',
      defaultTemplateDescription:
        'Format catatan yang diterapkan pada sesi baru.',
      customInstructions: 'Instruksi kustom',
      customInstructionsDescription:
        'Sesuaikan catatan Anda dengan memberikan panduan spesifik. Usahakan sejelas dan seringkas mungkin untuk hasil terbaik.',
      instructionsPlaceholder: 'Ketik instruksi Anda di sini',
      saveInstructionsFailed: 'Gagal menyimpan instruksi',
      exampleRemoveLifestyle: 'Hapus bagian tentang konseling gaya hidup',
      exampleIncludeQuotes: 'Sertakan kutipan pasien kata demi kata',
      examplePlanBullets: 'Pertahankan bagian rencana dalam poin-poin',
      exampleFollowUpTimeline: 'Selalu akhiri dengan linimasa tindak lanjut',
    },
    tasks: {
      title: 'Preferensi Tugas',
      customInstructions: 'Instruksi ekstraksi tugas',
      customInstructionsDescription:
        'Jelaskan tugas tindak lanjut apa yang penting untuk alur kerja Anda, apa yang harus disertakan, dilewati, atau ditekankan. Diterapkan setiap kali tugas diekstrak dari sesi Anda.',
      instructionsPlaceholder: 'Ketik instruksi Anda di sini',
      saveInstructionsFailed: 'Gagal menyimpan instruksi',
    },
    appGrants: {
      authorizedAgents: 'Agen yang diotorisasi',
      authorizedAgentsDescription:
        'Agen yang telah Anda otorisasi untuk bertindak atas nama Anda. Mencabut izin memaksa agen meminta persetujuan lagi sebelum dapat berjalan.',
    },
    organization: {
      layers: 'Lapisan',
      layersDescription: 'Atur Eluve agar paling sesuai dengan praktik Anda.',
    },
    chat: {
      title: 'Preferensi Chat',
      resetSuccess: 'Pengaturan diatur ulang ke default',
      resetFailed: 'Gagal mengatur ulang pengaturan',
      outputPreferences: 'Preferensi Output',
      outputPreferencesSavedOne:
        '{count} preferensi tersimpan untuk format respons dan tingkat detail.',
      outputPreferencesSavedMany:
        '{count} preferensi tersimpan untuk format respons dan tingkat detail.',
      outputPreferencesConfigure:
        'Konfigurasikan format respons, tingkat detail, dan instruksi kustom.',
      customInstructions: 'Instruksi Kustom',
      customInstructionsDescription:
        'Panduan tambahan yang harus diikuti setiap respons chat.',
      conversationStarters: 'Pembuka Percakapan',
      conversationStartersDescription: 'Saran perintah saat memulai chat baru.',
      knowledgeBase: 'Basis Pengetahuan',
      knowledgeBaseDescription:
        'Pilih sumber pengetahuan yang akan disertakan dalam konteks chat.',
      resetToDefault: 'Atur Ulang ke Default',
      resetDialogDescription:
        'Ini akan menghapus semua pengaturan chat kustom Anda termasuk instruksi kustom, pembuka percakapan, dan file yang diunggah. Chat akan kembali ke pengaturan default. Tindakan ini tidak dapat dibatalkan.',
      customInstructionsPageTitle: 'Instruksi Kustom Chat',
      saveInstructionsFailed: 'Gagal menyimpan instruksi kustom',
      exampleRemoveParts: 'Hapus bagian tentang...',
      exampleIncludeDiscussion: 'Sertakan pembahasan tentang...',
      exampleMoreConcise: 'Buat catatan lebih ringkas',
      exampleMoreDetailsPlan: 'Tambahkan lebih banyak detail di bagian rencana',
      outputPreferencesPageDescription:
        'Konfigurasikan format respons, tingkat detail, dan instruksi kustom. Tautkan ke pembuka percakapan.',
      preferenceCountOne: '{count} preferensi',
      preferenceCountMany: '{count} preferensi',
      editPreferenceLabel: 'Edit {label}',
      deletePreferenceLabel: 'Hapus {label}',
      noOutputPreferences: 'Tidak ada preferensi output yang dikonfigurasi',
      newOutputPreference: 'Preferensi Output Baru',
      editOutputPreference: 'Edit Preferensi Output',
      deletePreferenceTitle: 'Hapus Preferensi?',
      deletePreferenceDescription:
        'Ini akan menghapus preferensi output ini. Pembuka percakapan apa pun yang tertaut akan dilepas tautannya. Tindakan ini tidak dapat dibatalkan.',
      savePreferenceFailed: 'Gagal menyimpan preferensi',
      deletePreferenceFailed: 'Gagal menghapus preferensi',
      updateInstructionsFailed: 'Gagal memperbarui instruksi kustom',
      updateContextSourcesFailed: 'Gagal memperbarui sumber konteks',
      updateStartersFailed: 'Gagal memperbarui pembuka percakapan',
      updateFilesFailed: 'Gagal memperbarui file',
    },
    insights: {
      title: 'Preferensi Insight',
      savePreferences: 'Simpan Preferensi',
      savePreferencesFailed: 'Gagal menyimpan preferensi',
      preferencesSaved: 'Preferensi disimpan',
      previewAgainst: 'Pratinjau dengan',
      samplePatient: 'Pasien contoh (Edward Hyde)',
      generatePreview: 'Buat Pratinjau',
      generatingPreview: 'Membuat pratinjau…',
      previewOutOfDate:
        'Pratinjau sudah kedaluwarsa. Klik Buat untuk menerapkan perubahan Anda.',
      noRegenNeeded: 'Tidak ada janji temu mendatang yang perlu dibuat ulang',
      regeneratingOne: 'Membuat ulang insight untuk {count} janji temu',
      regeneratingMany: 'Membuat ulang insight untuk {count} janji temu',
      regenerateFailed: 'Gagal membuat ulang insight',
      resetFailed: 'Gagal mengatur ulang preferensi',
      unsavedChangesTitle: 'Perubahan Belum Disimpan',
      unsavedChangesDescription:
        'Anda memiliki perubahan yang belum disimpan. Yakin ingin meninggalkan halaman ini? Perubahan Anda akan hilang.',
      stay: 'Tetap di Sini',
      leave: 'Keluar',
      regenerateDialogTitle: 'Buat Ulang PVI?',
      regenerateDialogDescriptionOne:
        'Perubahan Anda akan berlaku untuk janji temu baru mulai besok. Apakah Anda ingin membuat ulang Insight AI untuk {count} janji temu mendatang Anda?',
      regenerateDialogDescriptionMany:
        'Perubahan Anda akan berlaku untuk janji temu baru mulai besok. Apakah Anda ingin membuat ulang Insight AI untuk {count} janji temu mendatang Anda?',
      notNow: 'Nanti saja',
      regenerateNow: 'Buat ulang sekarang',
      resetDialogDescription:
        'Ini akan menghapus preferensi insight kustom Anda dan kembali ke pengaturan default. Tindakan ini tidak dapat dibatalkan.',
      previewInvalidResponse:
        'Pratinjau mengembalikan respons yang tidak valid. Silakan coba lagi.',
      previewGenerationFailed: 'Pembuatan pratinjau gagal. Silakan coba lagi.',
      previewTimedOut: 'Waktu pembuatan pratinjau habis. Silakan coba lagi.',
      previewStartFailed:
        'Tidak dapat memulai pembuatan pratinjau. Silakan coba lagi.',
    },
  },
  appointmentPage: {
    gotIt: 'Mengerti',
    save: 'Simpan',
    retry: 'Coba lagi',
    tryAgain: 'Coba Lagi',
    areYouSure: 'Apakah Anda yakin?',
    noLongerEditable:
      'Anda tidak akan dapat lagi mengedit catatan ini di Eluve.',
    signNote: 'Tandatangani Catatan',
    previewPdf: 'Pratinjau PDF',
    pdfPrepareFailed: 'Gagal menyiapkan PDF',
    experiments: 'Eksperimen',
    canceledInEhr: 'Janji temu ini dibatalkan di EHR Anda.',
    summaryReadyTitle: 'Ringkasan siap!',
    summaryReadyDescription: 'Ringkasan Anda siap untuk ditinjau.',
    summariesReadyTitle: 'Ringkasan siap!',
    summariesReadyDescription: 'Ringkasan Anda siap untuk ditinjau.',
    appointmentsHeading: 'Janji Temu',
    appointmentsLoadFailed: 'Gagal memuat data janji temu.',
    saveBlockFailed: 'Gagal menyimpan blok',
    improveYourNotes: 'Tingkatkan catatan Anda',
    saveSummaryFailed: 'Gagal menyimpan ringkasan',
    disclaimer: 'Penafian',
    details: {
      title: 'Detail',
      appointmentHeading: 'Janji Temu',
      date: 'Tanggal',
      time: 'Waktu',
      location: 'Lokasi',
      type: 'Jenis',
      owner: 'Pemilik',
      artifacts: 'Artefak',
      updateFailed: 'Tidak dapat memperbarui detail janji temu',
      noLocationSpecified: 'Lokasi tidak ditentukan',
      noDateSpecified: 'Tanggal tidak ditentukan',
      startTime: 'Waktu Mulai',
      end: 'Selesai',
      noType: 'Tanpa Jenis',
    },
    header: {
      selectPatientFirst: 'Silakan pilih pasien terlebih dahulu!',
      appointmentDetailsAria: 'Detail janji temu',
    },
    emailSuperbill: {
      emailSubject: 'Superbill Anda untuk {date} - {tenantName}',
      emailBodyWithDoctor:
        'Halo{name}, terlampir Superbill Anda untuk kunjungan Anda dengan Dr. {doctorName} pada {date}.',
      emailBody:
        'Halo{name}, terlampir Superbill Anda untuk kunjungan Anda pada {date}.',
      updateEmailFailed: 'Email pasien tidak dapat diperbarui.',
      sendFailed: 'Email tidak dapat dikirim. Silakan coba lagi nanti!',
      sentTitle: 'Email Terkirim',
      sentDescription: 'Email Anda telah berhasil dikirim.',
      emailPdfTooltip: 'Kirim PDF via Email',
      title: 'Kirim Email ke Pasien',
      description: 'Harap tinjau informasi sebelum mengirim',
      emailAddress: 'Alamat Email',
      updatePatientEmailLabel: 'Perbarui juga email pasien di akun mereka',
      subjectLabel: 'Subjek',
      subjectPlaceholder: 'Superbill Anda',
      messageLabel: 'Pesan',
      messagePlaceholder: 'Deskripsi',
      sendEmail: 'Kirim Email',
    },
    syncToEhr: {
      noteSignedSuccessfully: 'Catatan Berhasil Ditandatangani',
      noteDraftedSuccessfully: 'Draf Catatan Berhasil Dibuat',
      noteSynced: 'Catatan Anda telah disinkronkan.',
      signFailed: 'Gagal menandatangani catatan.',
      syncedToEhr: 'Catatan Anda berhasil disinkronkan ke {ehrName}.',
      syncedButSignFailed:
        'Catatan Anda berhasil disinkronkan ke {ehrName}, tetapi terjadi kesalahan saat menandatangani catatan di Eluve.',
      syncNotAvailable: 'Sinkronisasi ke EHR tidak tersedia',
      syncToEhrButton: 'Sinkronkan ke EHR',
      signExternalChart: 'Tandatangani rekam medis eksternal',
      exportedTo: 'Isi catatan ini akan diekspor ke {ehrName}',
      asA: 'sebagai',
      signedNote: 'catatan yang ditandatangani',
      draftNote: 'draf',
      forPatient: 'untuk pasien',
      confirmSyncAndSign: 'Ya, Sinkronkan dan Tandatangani Catatan',
      confirmSyncAsDraft: 'Ya, Sinkronkan Catatan sebagai Draf',
      syncingTo: 'Menyinkronkan ke {ehrName}',
      syncingDescription:
        'Kami sedang menyinkronkan ke {ehrName}. Ini hanya akan memakan waktu beberapa saat.',
      addChartUrlTitle: 'Tambahkan URL Rekam Medis',
      chartUrlPlaceholder: 'URL rekam medis',
      addChartUrlAndSign: 'Tambahkan URL Rekam Medis dan Tandatangani',
      manuallyAddChartUrl: 'Tambahkan URL Rekam Medis Secara Manual',
    },
    signNoteOnEluve: {
      noteSigned: 'Catatan Anda telah ditandatangani.',
      notOwner:
        'Hanya pemilik janji temu yang dapat menandatangani catatan ini.',
      chartNotModified:
        'Rekam medis belum diubah. Harap isi rekam medis sebelum menandatangani catatan.',
      selectLocation: 'Pilih lokasi sebelum menandatangani catatan.',
      selectPatient: 'Pilih pasien sebelum menandatangani catatan.',
      confirmSignNote: 'Ya, Tandatangani Catatan',
    },
    signedSummary: {
      cancelAmendmentFailed: 'Gagal membatalkan amendemen',
      submitAmendmentFailed: 'Gagal mengirim amendemen',
      discardAmendment: 'Buang Amendemen',
      amendChart: 'Ubah Rekam Medis',
    },
    audioLost: {
      title: 'Janji temu ini mungkin kehilangan sebagian audio',
      lastAudioReceived:
        'Audio terakhir yang kami terima adalah {ago} — sepertinya perangkat masuk mode tidur atau browser ditangguhkan setelah itu. Pembicaraan selama waktu tersebut tidak terekam dan tidak dapat dipulihkan.',
      noAudioSinceStart:
        'Kami mulai merekam {ago}, tetapi belum menerima audio sejak saat itu — ini biasanya terjadi saat perangkat masuk mode tidur atau browser ditangguhkan. Jika Anda sedang berbicara, audio tersebut tidak terekam dan tidak dapat dipulihkan.',
      avoidNextTime: 'Untuk menghindari hal ini di lain waktu:',
      onComputerLabel: 'Di komputer:',
      onComputerBody:
        'biarkan tab browser ini terbuka dan berada di depan saat merekam — jangan beralih ke tab lain atau membiarkan komputer masuk mode tidur.',
      onPhoneLabel: 'Di ponsel atau tablet:',
      onPhoneBody:
        'biarkan browser tetap terbuka dan matikan kunci otomatis / kunci layar agar layar tidak mati saat merekam.',
      moreThanADayAgo: 'lebih dari sehari yang lalu',
      aboutSecondsAgoOne: 'sekitar 1 detik yang lalu',
      aboutSecondsAgo: 'sekitar {count} detik yang lalu',
      aboutMinutesAgoOne: 'sekitar 1 menit yang lalu',
      aboutMinutesAgo: 'sekitar {count} menit yang lalu',
      aboutHoursAgoOne: 'sekitar 1 jam yang lalu',
      aboutHoursAgo: 'sekitar {count} jam yang lalu',
      agoAtTime: '{ago} (pukul {time})',
    },
    presence: {
      title: 'Sesi Ini Lebih Lama dari Biasanya',
      beforeCountdown:
        'Jika Anda ingin melanjutkan perekaman, silakan klik tombol di bawah. Jika tidak, dalam',
      afterCountdown:
        'sesi akan dijeda secara otomatis. Anda masih dapat melanjutkannya nanti jika diperlukan.',
    },
    micFailed: {
      title: 'Mikrofon Anda Terputus',
      description:
        'Perekaman telah dijeda. Sebelum melanjutkan, pastikan mikrofon yang dipilih di bawah adalah yang ingin Anda gunakan.',
      stayPaused: 'Tetap Dijeda',
    },
    recordingFailed: {
      title: 'Sesi tidak lagi berlangsung.',
      description: 'Segarkan halaman untuk melanjutkan sesi.',
      refreshPage: 'Segarkan Halaman',
    },
    storageFailure: {
      quotaTitle: 'Penyimpanan browser Anda penuh',
      quotaDescription:
        'Perekaman dijeda, tetapi audio yang sudah terekam tersimpan. Kosongkan ruang disk atau muat ulang halaman untuk melanjutkan. Anda juga dapat membuat catatan sekarang.',
      unhealthyTitle: 'Penyimpanan browser Anda tidak tersedia',
      unhealthyDescription:
        'Perekaman dijeda, tetapi audio yang sudah terekam tersimpan. Muat ulang halaman untuk melanjutkan, atau coba browser lain jika terus terjadi. Anda juga dapat membuat catatan sekarang.',
      continue: 'Lanjutkan',
      refreshPage: 'Muat Ulang Halaman',
      resumeBlockedTooltip:
        'Penyimpanan browser penuh atau tidak tersedia. Muat ulang halaman untuk melanjutkan.',
    },
    newAppointment: {
      sessionSettings: 'Pengaturan Sesi',
      noteSettings: 'Pengaturan Catatan',
      viewMoreOptions: 'Lihat Opsi Lainnya',
      viewLessOptions: 'Lihat Lebih Sedikit Opsi',
      playDisclaimer: 'Putar penafian sebelum merekam',
      startSession: 'Mulai Sesi',
      selectMicrophoneTooltip: 'Pilih mikrofon untuk memulai sesi.',
      ownerOnlyStartTooltip:
        'Hanya pemilik janji temu yang dapat memulai sesi.',
      micAccessTooltip:
        'Tidak dapat mengakses mikrofon. Silakan periksa pengaturan Anda',
      noAudioTooltip:
        'Tidak ada audio yang terdeteksi. Periksa mikrofon dan volume Anda.',
      alreadyInSessionTooltip: 'Sudah ada janji temu yang sedang berlangsung.',
      sessionStartingTooltip: 'Sesi sedang dimulai, harap tunggu...',
      manualChartingStartFailed: 'Gagal memulai sesi untuk pencatatan manual.',
      duplicatePreviousChart: 'Duplikat Rekam Medis Sebelumnya',
      selectChart: 'Pilih Rekam Medis',
      duplicateChartTitle: 'Duplikat Rekam Medis',
      duplicateChartDescription: 'Pilih rekam medis yang ingin Anda duplikat',
      transcribeTab: 'Transkripsi',
      manualChartingTab: 'Pencatatan Manual',
    },
    chiefComplaint: {
      updateFailed: 'Detail janji temu tidak dapat diperbarui.',
      updateContext: 'Perbarui Konteks',
      addContext: 'Tambahkan Konteks',
      title: 'Keluhan Utama & Alasan Kunjungan',
      chiefComplaintLabel: 'Keluhan Utama',
      chiefComplaintPlaceholder: 'Masukkan keluhan utama',
      reasonForVisitLabel: 'Alasan Kunjungan',
      reasonForVisitPlaceholder: 'Masukkan alasan kunjungan',
    },
    summaryStates: {
      pendingDataDescription: 'Kami akan segera membuat catatan Anda.',
      takingLongerDescription:
        'Kami masih mengerjakan catatan Anda. Anda dapat meninggalkan halaman ini dan memulai sesi baru! Kami akan memberi tahu Anda saat catatan Anda siap.',
      browserOnDevice: '{browser} di {device}',
      uploadNeededPrefixOne: 'Rekaman Anda masih perlu diunggah dari',
      uploadNeededPrefixMany: 'Rekaman Anda masih perlu diunggah dari',
      uploadNeededSuffixOne:
        '. Untuk membuat catatan Anda, biarkan Eluve terbuka di browser tersebut hingga selesai.',
      uploadNeededSuffixMany:
        '. Untuk membuat catatan Anda, biarkan Eluve terbuka di browser tersebut hingga semuanya selesai.',
    },
    summaryFailed: {
      resumeRecording: 'Lanjutkan perekaman',
    },
    previsitInsights: {
      title: 'Wawasan Pra-Kunjungan',
      tooltip:
        'Ringkasan yang dihasilkan AI dari catatan kunjungan pasien sebelumnya.',
      autoGenerateNotice:
        'Wawasan Pra-Kunjungan dibuat secara otomatis sekitar {minutes} menit sebelum kunjungan.',
      generateNow: 'Buat sekarang',
      selectPatient: 'Pilih pasien untuk membuat wawasan pra-kunjungan.',
    },
    documents: {
      deleted: 'Dokumen dihapus',
      deleteFailed: 'Gagal menghapus dokumen',
      renameFailed: 'Gagal mengganti nama dokumen',
      newDocument: 'Dokumen baru',
      generated: 'Dokumen dibuat',
      unknownError: 'Terjadi kesalahan yang tidak diketahui.',
      selectPatientFirst: 'Pilih pasien terlebih dahulu untuk membuat dokumen',
    },
    carePlan: {
      preparing: 'Menyiapkan rencana perawatan Anda…',
      willBeGenerated:
        'Rencana perawatan akan dibuat dari temuan yang diterapkan.',
    },
    filesDrawer: {
      trigger: 'Berkas',
      title: 'Berkas Janji Temu',
      filesWillBeRemoved:
        'Berkas akan dihapus dari perangkat Anda setelah janji temu selesai',
      noLocalFiles: 'Tidak ada berkas lokal di perangkat ini.',
      download: 'Unduh',
    },
    additionalNotes: {
      updateFailed: 'Gagal memperbarui catatan tambahan',
    },
    summaryComparison: {
      loading: 'Memuat Perbandingan Ringkasan...',
      returnToSession: 'Kembali ke sesi Anda',
      defaultTemplateTooltip:
        'Ini ditetapkan sebagai templat default Anda. Anda dapat mengubahnya di pengaturan.',
      select: 'Pilih',
      generating: 'Membuat...',
      generateSummaries: 'Buat Ringkasan',
      inactiveTemplate: 'Templat Tidak Aktif',
      useThisSummary: 'Gunakan ringkasan ini',
      alreadySigned: 'Catatan ini sudah ditandatangani',
      alreadyCurrent: 'Catatan ini sudah ditetapkan sebagai ringkasan saat ini',
    },
    rerunTranscription: {
      rerun: 'Jalankan ulang transkripsi pada berkas audio',
      inProgress: 'Sedang mentranskripsi berkas audio',
    },
    manualCharting: {
      automateNotesTitle: 'Ingin mengotomatiskan catatan Anda?',
      automateNotesDescription:
        'Anda dapat mulai merekam, tetapi ini akan menimpa catatan manual Anda yang ada.',
      startRecording: 'Mulai Merekam',
    },
    controls: {
      resumeSession: 'Lanjutkan Sesi',
      generateNote: 'Buat Catatan',
      pause: 'Jeda',
      resume: 'Lanjutkan',
      processing: 'Memproses',
      anotherAppointmentInSession: 'Janji temu lain sedang berlangsung',
    },
    clientRecap: {
      emptySummary: 'Ringkasan rekap klien kosong',
      emailSubject: 'Tindak lanjut dari sesi hari ini ({date})',
      copiedToClipboard:
        'Isi email disalin ke papan klip — tempelkan ke email Anda',
      sendMailTooltip: 'Kirim email ke pasien',
    },
    sampleTranscript: {
      addFailed: 'Transkrip contoh tidak dapat ditambahkan.',
      prompt:
        'Tidak dapat merekam janji temu sekarang? Coba transkrip contoh untuk melihat cara kerja Eluve!',
      tryButton: 'Coba transkrip',
    },
    superbill: {
      title: 'Superbill',
      viewPdf: 'Lihat PDF',
    },
    uploadAudio: {
      unsupportedFormat: 'Format berkas tidak didukung',
      fileSystemUnavailable: 'Sistem berkas tidak tersedia',
      uploadFailed: 'Gagal mengunggah berkas',
      uploadFile: 'Unggah Berkas',
      uploadingRecording: 'Mengunggah Rekaman',
    },
    versionHistory: {
      title: 'Riwayat Versi',
      startedSession: 'memulai sesi',
      endedSession: 'mengakhiri sesi',
      editedChart: 'mengedit rekam medis',
      signedChart: 'menandatangani rekam medis',
      amended: 'mengubah',
      signedWithAmendments: 'menandatangani dengan amendemen',
      lastEditedChart: 'terakhir mengedit rekam medis',
      generatedSuperbill: 'membuat superbill',
      updatedSuperbill: 'memperbarui superbill',
    },
    lastSaved: {
      lastAmendedBy: 'Terakhir diubah oleh {name} pada {time}',
      lastSignedBy: 'Terakhir ditandatangani oleh {name} pada {time}',
      lastSavedAt: 'Terakhir disimpan pada {time}',
      saving: 'Menyimpan...',
    },
    overwriteSummary: {
      title: 'Timpa catatan yang ada?',
      description:
        'Jika Anda membuat catatan baru, catatan Anda yang ada akan ditimpa. Apakah tidak apa-apa?',
      no: 'Tidak',
      confirm: 'Ya, Lanjutkan ke Catatan Baru',
    },
    insights: {
      reasonForVisitTab: 'Alasan Kunjungan',
      considerationsTab: 'Pertimbangan',
      generateFailed:
        'Kami tidak dapat membuat wawasan Anda. Silakan coba lagi nanti!',
      generateOutputFailed:
        'Terjadi kesalahan saat membuat keluaran. Silakan coba lagi nanti.',
      eluveInsights: 'Eluve Insights',
      tagline:
        'Tingkatkan akurasi diagnosis dan hasil pasien dengan wawasan yang didukung AI.',
      run: 'Jalankan Wawasan',
      rerun: 'Jalankan Ulang Wawasan',
      noInsightsTitle: 'Belum ada wawasan',
      noInsightsDescription:
        'Kami tidak dapat membuat wawasan berdasarkan informasi yang tersedia saat ini. Coba lagi setelah percakapan lebih panjang.',
    },
    redFlags: {
      wasHelpful: 'Apakah wawasan ini bermanfaat?',
      noneTitle: 'Tidak ada tanda bahaya yang teridentifikasi',
      noneDescription:
        'Tinjau tab Diagnosis Banding untuk melihat bagaimana indikator utama dinilai berdasarkan percakapan dan bukti.',
      viewDdx: 'Lihat DDx',
    },
    waveform: {
      muted: 'Dibisukan',
    },
  },
  home: {
    toasts: {
      failedToRetrieveAppointments: 'Gagal mengambil janji temu',
    },
    calendarSidebar: {
      title: 'Kalender',
    },
    snippets: {
      title: 'Snippet',
      descriptionPrefix:
        'Buat teks yang dapat digunakan kembali untuk mempermudah dokumentasi Anda. Untuk menyisipkan snippet, ketik',
      descriptionSuffix: 'di editor dan pilih pintasan Anda.',
      countLabelOne: '{count} snippet',
      countLabelMany: '{count} snippet',
      actionsAriaLabel: 'Tindakan snippet',
      export: 'Ekspor',
      import: 'Impor',
      createNew: 'Buat Baru',
      loading: 'Memuat ...',
      noSnippets: 'Belum ada snippet yang dikonfigurasi',
      editSnippet: 'Edit {title}',
      deleteSnippet: 'Hapus {title}',
      importSuccess: '{count} snippet berhasil diimpor',
      importParseError: 'Gagal membaca file snippet',
    },
    transcriptionConfidence: {
      tooFarTitle: 'Apakah Anda terlalu jauh dari perangkat?',
      tooFarDescription:
        'Coba dekatkan perangkat Anda agar kami dapat menangkap audio dengan baik.',
    },
    ehrImport: {
      noEhrAssociationsTitle: 'Tidak ada asosiasi EHR',
      noEhrAssociationsDescription:
        'Lokasi tidak terkait dengan EHR eksternal. Silakan minta admin Anda untuk mengaitkan lokasi dengan EHR.',
      successTitle: 'Berhasil!',
      importedFrom: 'Pasien dan janji temu diimpor dari:',
      failedImportingFrom: 'Gagal mengimpor dari:',
      failedTitle: 'Gagal mengimpor data',
      failedImportingPatientsFrom:
        'Gagal mengimpor pasien dan janji temu dari:',
      refreshAndTryAgain: 'Muat ulang halaman dan coba lagi.',
    },
    ehrOnboarding: {
      allSetTitle: 'Semua sudah siap!',
      allSetDescription:
        'Integrasi EHR Anda sudah siap! Sekarang Anda dapat melihat janji temu mendatang di beranda.',
      done: 'Selesai',
      importingTitle: 'Mengimpor janji temu',
      importingDescription:
        'Impor pertama membutuhkan beberapa detik, tetapi setelahnya kami akan menyinkronkan EHR Anda secara otomatis.',
      importing: 'Mengimpor...',
      importTitle: 'Impor janji temu',
      importDescription:
        'Impor data EHR agar Eluve dapat bekerja lancar dengan alur kerja Anda',
      startImport: 'Mulai Impor',
      dataSafety: 'Pelajari cara Eluve menjaga keamanan data Anda',
      extensionInstalledTitle: 'Ekstensi terpasang!',
      connectEhr: 'Hubungkan akun EHR Anda dengan Eluve',
      selectLocationPlaceholder: 'Pilih lokasi {tenantName} Anda',
      noLocationsFound: 'Lokasi tidak ditemukan',
      contactAdminForLocation:
        'Silakan hubungi admin organisasi untuk menyiapkan lokasi',
      next: 'Berikutnya',
    },
    emptyState: {
      noUpcomingAppointments: 'Tidak ada janji temu mendatang',
      finishSetupDescription:
        'Selesaikan penyiapan integrasi EHR Anda untuk menyinkronkan janji temu dengan Eluve.',
      importAppointments: 'Impor Janji Temu',
      newSession: 'Sesi Baru',
      noUpcomingNext7Days:
        'Anda tidak memiliki janji temu untuk 7 hari ke depan. Jika Anda baru saja menambahkan janji temu di EHR dan belum muncul, coba muat ulang.',
      refresh: 'Muat Ulang',
      troubleshoot: 'Pemecahan Masalah',
      downloadExtensionDescription:
        'Anda tidak memiliki janji temu. Unduh ekstensi Eluve untuk integrasi yang lancar.',
      installExtension: 'Pasang Ekstensi',
      startRecordingSession: 'Mulai sesi rekaman',
    },
    ehrImporter: {
      installExtensionTitle: 'Pasang ekstensi',
      installExtensionDescription:
        'Dapatkan ekstensi Chrome untuk menyinkronkan catatan Anda kembali ke EHR dengan mudah.',
      ehrIntegration: 'Integrasi EHR',
      almostThere: 'Hampir selesai! Selesaikan penyiapan integrasi Anda!',
      accountsConnected: '{count} akun terhubung',
      problemsSyncing: 'Masalah saat menyinkronkan dengan EHR Anda',
      completeOnboarding: 'Selesaikan orientasi',
      importPatientsAppointments: 'Impor pasien dan janji temu',
    },
    agenda: {
      patientNotSpecified: 'Pasien Tidak Ditentukan',
    },
    loader: {
      loadingAppointments: 'Memuat Janji Temu ...',
    },
    tenantsList: {
      pendingApproval: 'Menunggu Persetujuan',
      organization: 'Organisasi',
      role: 'Peran',
      memberSince: 'Anggota Sejak',
      createdAt: 'Dibuat pada',
    },
  },
  tenantAdmin: {
    common: {
      save: 'Simpan',
      saveChanges: 'Simpan Perubahan',
      create: 'Buat',
      add: 'Tambah',
      users: 'Pengguna',
      areYouSure: 'Apakah Anda yakin?',
      thereWasAnError: 'Terjadi kesalahan',
      invalidFileExtension: 'Ekstensi file tidak valid.',
      actionsColumn: 'Tindakan',
      detailsColumn: 'Detail',
      nameColumn: 'Nama',
    },
    location: {
      editName: 'Ubah nama lokasi',
      detailsUpdated: 'Detail lokasi diperbarui',
      detailsUpdateFailed: 'Gagal memperbarui detail lokasi',
      logoUpdated: 'Logo diperbarui',
      logoUpdateFailed: 'Gagal memperbarui logo',
      logoUploadFailed: 'Gagal mengunggah logo',
      displayNameUpdated: 'Nama tampilan diperbarui',
      displayNameUpdateFailed: 'Gagal memperbarui nama tampilan',
      changeLogoTooltip: 'Klik untuk mengganti logo',
      uploadLogoTooltip: 'Klik untuk mengunggah logo',
      logoAlt: 'Logo {name}',
      uploadLogo: 'Unggah logo',
      removeLogo: 'Hapus logo',
      autoCreatedBadge: 'Dibuat otomatis',
      renamedBadge: 'diganti nama',
      detailsTitle: 'Detail Lokasi',
      hideAdvancedSettings: 'Sembunyikan Pengaturan Lanjutan',
      showAdvancedSettings: 'Tampilkan Pengaturan Lanjutan',
      externalEhrLabel: 'EHR Eksternal',
      selectEhr: 'Pilih EHR',
      removeEhrTooltip: 'Hapus EHR dari lokasi',
      or: 'ATAU',
      createNewEhr: 'Buat EHR Baru',
      externalIdLabel: 'ID Eksternal',
      addressLabel: 'Alamat',
      phoneNumberLabel: 'Nomor Telepon',
      inheritedDefaultsTitle: 'Default yang diwariskan',
      inheritedDefaultsDescription:
        'Diterapkan ke lokasi ini dan diwariskan ke lokasi turunan yang tidak mengatur nilainya sendiri.',
      businessNameLabel: 'Nama Bisnis',
      posCodeLabel: 'Kode Place of Service (POS)',
      taxIdLabel: 'ID Pajak',
      replyToEmailLabel: 'Email Balasan',
      addUser: 'Tambah Pengguna',
      billingCodesTitle: 'Kode Penagihan',
      usersStatDescription: 'Dengan akses ke lokasi ini',
      appointmentsStatTitle: 'Janji Temu',
      appointmentsStatDescription: 'Direkam di lokasi ini',
      sourceOrgIdLabel: 'ID Organisasi Sumber',
      sourceOrgIdHint: 'Kunci pencocokan & deduplikasi — hanya baca',
      sourceNameLabel: 'Nama sumber (OrganizationName)',
      tabDetails: 'Detail',
      tabUserPermissions: 'Izin pengguna',
      tabPeople: 'Orang',
      tabServices: 'Layanan',
      tabBillingCodes: 'Kode penagihan',
      schedulingTitle: 'Penjadwalan',
      schedulingTimezoneLabel: 'Zona waktu penjadwalan',
      openingHoursLabel: 'Jam buka',
      schedulingUnavailable: 'Sesi FHIR tidak tersedia.',
      schedulingLoading: 'Memuat…',
      schedulingNotMirrored: 'Lokasi ini belum dicerminkan untuk penjadwalan.',
      schedulingNoTimezone:
        'Tanpa zona waktu, klinik ini tidak dapat dipesan — jam praktik penyedia tidak punya kisi untuk ditempatkan.',
      practiceRolesTitle: 'Peran praktik di lokasi ini',
      practiceRolesDescription:
        'Resepsionis memesan janji temu; klinisi juga memiliki dokumentasi klinis. Default mengikuti peran anggota di seluruh organisasi.',
      practiceRolesLoadFailed:
        'Tidak dapat memuat peran praktik — pengeditan dinonaktifkan.',
      practiceRoleDefault: 'Default',
      practiceRoleUnavailable: 'Tidak tersedia',
      practiceRoleClinician: 'Klinisi',
      practiceRoleFrontDesk: 'Resepsionis',
      practiceRoleSet: 'Peran diatur ke {role}.',
      practiceRoleCleared: 'Peran dihapus.',
      practiceRoleAccessSyncFailed:
        'Izin akses mereka tidak diperbarui — gunakan Sinkronkan ulang kebijakan.',
      practiceRoleSetFailed: 'Tidak dapat mengatur peran: {message}',
      practiceRoleUnknownError: 'kesalahan tidak diketahui',
      practiceRoleApiUnreachable: 'Gagal menghubungi API',
    },
    locations: {
      title: 'Lokasi',
      description:
        'Lokasi yang disinkronkan dari EMR Anda muncul di bawah — ganti nama lokasi mana pun, atau beralih ke tampilan Pohon untuk mengelola hierarki.',
      hubDescription:
        'Praktik Anda dalam satu tempat — pilih lokasi untuk mengelola detail, orang, dan penjadwalannya.',
      hubEmpty: 'Belum ada lokasi.',
      addLocation: 'Tambah lokasi',
      addLocationParentLabel: 'Induk',
      addLocationParentPlaceholder: 'Pilih induk',
      addLocationParentSearch: 'Cari lokasi',
      addLocationNameLabel: 'Nama',
      addLocationCancel: 'Batal',
      addLocationSubmit: 'Tambah',
      locationCreated: "Lokasi '{name}' dibuat",
      locationCreateFailed: "Gagal membuat lokasi '{name}'",
      rootFallback: 'Akar',
      empty:
        'Belum ada lokasi — beralih ke tampilan Pohon untuk menambahkannya.',
      locationColumn: 'Lokasi',
      sourceOrgIdColumn: 'ID Org Sumber',
      apptsColumn: 'Janji',
      openLocationAria: 'Buka {name}',
      loadFailed: 'Gagal memuat lokasi',
      tableView: 'Tabel',
      treeView: 'Pohon',
    },
    newEhr: {
      title: 'Buat EHR baru',
      vendorLabel: 'Vendor',
      selectVendor: 'Pilih Vendor',
      domainLabel: 'Domain',
      domainPlaceholder: 'Masukkan Domain',
      secretConfiguration: 'Konfigurasi Rahasia',
      plaintextConfiguration: 'Konfigurasi Teks Biasa',
      enterField: 'Masukkan {field}',
      addNewEhr: 'Tambah EHR baru',
    },
    users: {
      inviteUser: 'Undang Pengguna',
      inviteSendFailed: 'Undangan tidak dapat dikirim.',
      inviteNewUserTitle: 'Undang Pengguna Baru',
      userRoleLabel: 'Peran Pengguna',
      roleAdmin: 'Admin',
      roleMember: 'Anggota',
      roleDescription:
        'Admin dapat melihat semua pasien dan janji temu, serta mengelola pengguna dan pengaturan organisasi. Catatan: Anda dapat mengubah peran pengguna nanti.',
      emailLabel: 'Alamat Email',
      emailPlaceholder: 'budi.santoso@contoh.com',
      firstNameLabel: 'Nama Depan',
      firstNamePlaceholder: 'Budi',
      lastNameLabel: 'Nama Belakang',
      lastNamePlaceholder: 'Santoso',
      locationLabel: 'Lokasi',
      selectLocation: 'Pilih lokasi',
      sendInvitation: 'Kirim Undangan',
      inviteResendFailed: 'Email undangan tidak dapat dikirim ulang.',
      inviteRevokeFailed: 'Undangan tidak dapat dicabut.',
      resendEmail: 'Kirim ulang email',
      revokeInvite: 'Cabut undangan',
      resendConfirmation:
        'Ini akan mengirimkan email undangan lagi ke "{email}".',
      revokeConfirmation:
        'Ini akan memblokir pengguna ({email}) agar tidak dapat menerima undangan.',
      resendEmailAction: 'Kirim Ulang Email',
      revokeInviteAction: 'Cabut Undangan',
      excludeFailed:
        'Pengguna tidak dapat dikecualikan dari laporan penggunaan.',
      includeFailed:
        'Pengguna tidak dapat disertakan dalam laporan penggunaan.',
      emailDescription: 'Email: {email}',
      removeFailed: 'Pengguna tidak dapat dihapus dari organisasi.',
      roleChangeFailed: 'Peran pengguna tidak dapat diubah.',
      changeToAdmin: 'Ubah menjadi admin',
      changeToMember: 'Ubah menjadi anggota',
      includeInUsageReports: 'Sertakan dalam laporan penggunaan',
      excludeFromUsageReports: 'Kecualikan dari laporan penggunaan',
      removeUser: 'Hapus pengguna',
      removeConfirmation:
        'Ini akan menghapus pengguna ({email}) dari organisasi Anda.',
      roleChangeConfirmation:
        'Ini akan mengubah peran pengguna ({email}) menjadi "{role}".',
      excludeConfirmation:
        'Pengguna ini akan disembunyikan dari daftar ini dan tidak akan dihitung dalam laporan penggunaan.',
      removeUserAction: 'Hapus Pengguna',
      changeRoleAction: 'Ubah Peran',
      excludeUserAction: 'Kecualikan Pengguna',
      fullNameColumn: 'Nama Lengkap',
      emailColumn: 'Email',
      roleColumn: 'Peran',
      inviteStatusColumn: 'Status Undangan',
      statusColumn: 'Status',
      lastSeenColumn: 'Terakhir Dilihat',
      joinInviteDateColumn: 'Tanggal Bergabung/Undangan',
      invitePendingTag: 'Undangan Tertunda',
      inviteRevokedTag: 'Undangan Dicabut',
      inviteExpiredTag: 'Undangan Kedaluwarsa',
      showExcludedUsers: 'Tampilkan pengguna yang dikecualikan',
      excludedUsersTooltip:
        'Pengguna yang dikecualikan tidak dihitung dalam laporan penggunaan',
      searchPlaceholder: 'Cari pengguna berdasarkan nama atau email...',
      membersTitle: 'Anggota',
    },
    userGroups: {
      title: 'Grup Pengguna',
      createFailed: 'Gagal membuat grup pengguna',
      createUserGroup: 'Buat Grup Pengguna',
      newUserGroupTitle: 'Grup Pengguna Baru',
      groupNamePlaceholder: 'Masukkan nama grup',
      removeUserFailed: 'Kami tidak dapat menghapus pengguna dari grup.',
      removeUserTooltip: 'Hapus pengguna dari grup ini',
      addUserFailed: 'Kami tidak dapat menambahkan pengguna ke grup.',
      selectUserToAdd: 'Pilih pengguna untuk ditambahkan',
      searchUsers: 'Cari pengguna',
      noUsersToAdd: 'Tidak ada pengguna yang dapat ditambahkan.',
      noUsersInGroup: 'Belum ada pengguna dalam grup ini.',
    },
    codes: {
      medicalCodeConfigurationsTitle: 'Konfigurasi Kode Medis',
      bulkActions: 'Tindakan Massal',
      addIndividualCodes: 'Tambah Kode Satuan',
      medicalCodes: 'Kode Medis',
      codeTypeColumn: 'Jenis Kode',
      codeColumn: 'Kode',
      labelColumn: 'Label',
      priceColumn: 'Harga',
      removeConfigFailed: 'Gagal menghapus konfigurasi grup pengguna',
      removeCodeTooltip: 'Hapus kode dari grup ini',
      configCreated: 'Konfigurasi grup pengguna berhasil dibuat',
      configCreateFailed: 'Gagal membuat konfigurasi grup pengguna',
      newConfigTitle: 'Konfigurasi Kode Penagihan Baru',
      customLabel: 'Label Kustom',
      customLabelDescription:
        'Jika tidak diisi, label yang ada akan digunakan.',
      priceRequiredLabel: 'Harga (Wajib)',
      modifiersLabel: 'Modifier',
      modifiersDescription: 'Daftar modifier yang dipisahkan koma.',
      downloadingTitle: 'Mengunduh Kode Medis',
      preparingDownload: 'Menyiapkan unduhan Anda...',
      downloadComplete: 'Unduhan selesai!',
      downloadFailed: 'Gagal mengunduh kode medis. Silakan coba lagi.',
      downloadAllCodes: 'Unduh Semua Kode yang Tersedia',
      downloadEnabledCodes: 'Unduh Kode yang Diaktifkan',
      uploadTitle: 'Unggah Kode Medis',
      uploadInstructions:
        'Silakan pilih file CSV berisi kode medis untuk diunggah. File harus menyertakan kolom berikut:',
      uploadColumnCode: 'Kode medis (wajib)',
      uploadColumnType: 'Jenis kode, harus salah satu dari: {types} (wajib)',
      uploadColumnDescription: 'Deskripsi kode (opsional)',
      uploadColumnPrice:
        "Harga per unit dalam dolar, mis. '60' atau '120.50' (opsional)",
      uploadColumnModifiers: 'Daftar modifier yang dipisahkan koma (opsional)',
      uploadWarning:
        'Peringatan: Mengunggah file baru akan menggantikan SEMUA konfigurasi kode yang ada untuk grup ini.',
      selectFile: 'Pilih File',
      uploadFileLimits: 'Ukuran file maksimum: 5MB, hanya format CSV',
      uploadingFile: 'Mengunggah file Anda...',
      processingCodes: 'Memproses kode medis, ini mungkin memerlukan waktu...',
      uploadComplete: 'Unggahan selesai!',
      successfullyProcessed: 'Berhasil diproses:',
      codesCount: '{count} kode',
      skipped: 'Dilewati:',
      errors: 'Kesalahan:',
      moreErrors: '...dan {count} kesalahan lainnya',
      uploadFailed: 'Gagal mengunggah kode medis',
      uploadCodes: 'Unggah Kode',
    },
    noteRecovery: {
      title: 'Pemulihan Catatan',
      description:
        'Buat ulang catatan klinis untuk janji temu yang catatannya gagal, tidak pernah dibuat, atau macet. Hanya janji temu dari 7 hari terakhir yang ditampilkan — catatan yang lebih lama tidak dapat dibuat ulang di sini. Janji temu dengan catatan yang sudah ditandatangani dikecualikan; aktifkan “Tampilkan janji temu dengan catatan” untuk juga menyertakan yang sudah memiliki draf yang belum ditandatangani.',
      regenerateNote: 'Buat ulang catatan',
      patientColumn: 'Pasien',
      startDateColumn: 'Tanggal Mulai',
      userColumn: 'Pengguna',
      statusColumn: 'Status',
      filterByUser: 'Filter berdasarkan pengguna',
      filterByStatus: 'Filter berdasarkan status',
      allUsers: 'Semua pengguna',
      allStatuses: 'Semua status',
      showWithNotes: 'Tampilkan janji temu dengan catatan',
      regenerationStarted: 'Pembuatan ulang catatan dimulai',
      notPermitted:
        'Anda tidak diizinkan membuat ulang catatan untuk organisasi ini',
      alreadySigned:
        'Janji temu ini sudah memiliki catatan yang ditandatangani',
      regenerateFailed: 'Gagal membuat ulang catatan',
      regenerateDescriptionPrefix: 'Buat ulang catatan klinis untuk',
      regenerateDescriptionSuffix: 'menggunakan bundel templat yang dipilih.',
      templateBundle: 'Bundel templat',
      selectTemplateBundle: 'Pilih bundel templat',
      untitledBundle: 'Bundel tanpa judul',
      noBundles:
        'Tidak ada bundel templat aktif yang tersedia untuk organisasi ini.',
      activeWarningPrefix: 'Janji temu ini masih aktif. Membuat catatan akan',
      activeWarningBold: 'menyelesaikan janji temu',
      activeWarningSuffix: 'dan mengakhiri sesi.',
      activeAcknowledge:
        'Saya mengerti ini akan menyelesaikan janji temu yang aktif.',
    },
    sessionTypes: {
      title: 'Jenis Sesi',
      updated: 'Jenis sesi diperbarui',
      updateFailed: 'Gagal memperbarui jenis sesi',
      editTooltip: 'Ubah Jenis Sesi ini',
      updateTitle: 'Perbarui Jenis Sesi',
      isInitialVisitTypeLabel: 'Merupakan Jenis Kunjungan Awal',
      contextColumn: 'Konteks',
      contextPlaceholder: 'Deskripsi',
      isInitialVisitColumn: 'Kunjungan Awal',
    },
    general: {
      title: 'Umum',
      logoLabel: 'Logo',
      organizationNameLabel: 'Nama Organisasi',
      interfaceLanguageLabel: 'Bahasa Antarmuka',
      interfaceLanguageDescription:
        'Bahasa UI default untuk pengguna organisasi ini. Pengguna yang telah memilih bahasa sendiri tidak terpengaruh.',
      interfaceLanguageUpdateFailed: 'Gagal memperbarui bahasa antarmuka',
      changeInterfaceLanguageTitle: 'Ubah Bahasa Antarmuka',
      changeInterfaceLanguagePrefix: 'Ini akan mengubah UI untuk',
      someUsers: 'beberapa pengguna',
      userCountOne: '{count} pengguna',
      userCountMany: '{count} pengguna',
      changeInterfaceLanguageSuffix:
        'di organisasi ini, karena pengguna yang telah memilih bahasa secara eksplisit tidak terpengaruh.',
      editInterfaceLanguage: 'Ubah bahasa antarmuka',
      logoUpdateFailed: 'Gagal memperbarui logo organisasi',
      logoDeleteFailed: 'Gagal menghapus logo organisasi.',
      organizationLogoAlt: 'Logo organisasi',
      nameUpdateFailed: 'Gagal memperbarui nama organisasi',
      editNameTitle: 'Ubah Nama Organisasi',
      namePlaceholder: 'Masukkan nama organisasi',
      nameInputAria: 'Nama organisasi',
      editName: 'Ubah nama organisasi',
    },
  },
  patients: {
    common: {
      loading: 'Memuat…',
      checkingAccess: 'Memeriksa akses…',
      noFhirRecord: 'Tidak ada rekaman FHIR yang tersedia untuk pasien ini.',
      unknownError: 'Kesalahan tidak diketahui',
      saving: 'Menyimpan…',
      saveChanges: 'Simpan perubahan',
      keepEditing: 'Lanjutkan mengedit',
    },
    list: {
      title: 'Pasien',
      loadFailed: 'Gagal memuat data pasien.',
      searchPlaceholder: 'Cari...',
      details: 'Detail',
      firstName: 'Nama Depan',
      lastName: 'Nama Belakang',
      lastAppointment: 'Janji Temu Terakhir',
      dateOfBirth: 'Tanggal Lahir',
      importedFrom: 'Diimpor Dari',
      appointmentsCount: 'Jumlah Janji Temu',
      copyExternalId: 'Salin ID Eksternal Pasien',
      includeInactive: 'Sertakan tidak aktif/meninggal',
    },
    tabs: {
      overview: 'Ringkasan',
      appointments: 'Janji Temu',
      documents: 'Dokumen',
      importedNotes: 'Catatan Impor',
      artifacts: 'Artefak',
      carePlans: 'Rencana Perawatan',
      medicalProfile: 'Profil Medis',
      careTeam: 'Tim Perawatan',
      observations: 'Observasi',
      patientUploads: 'Unggahan Pasien',
    },
    detailsPage: {
      copyExternalId: 'Salin ID Eksternal',
      viewOnVendor: 'Lihat di {vendor}',
      dateOfBirth: 'Tanggal lahir:',
      age: 'Usia:',
      yearsOld: '{age} tahun',
      error: 'Kesalahan',
    },
    importedNotes: {
      viewPdf: 'Lihat PDF',
      createdAt: 'Dibuat Pada',
      actions: 'Tindakan',
      searchByName: 'Cari berdasarkan nama...',
    },
    profile: {
      allPatients: 'Semua pasien',
      askEluve: 'Tanya Eluve',
      sectionsAriaLabel: 'Bagian profil pasien',
      appointmentsLoadFailed: 'Gagal memuat data janji temu.',
      documentsLoadFailed: 'Gagal memuat data dokumen.',
      importedNotesHeading: 'Catatan impor',
      importedNotesLoadFailed: 'Gagal memuat catatan impor.',
      overviewEmptyDescription: 'Informasi medis pasien akan berada di sini.',
    },
    rail: {
      editProfile: 'Edit profil',
      moreActions: 'Tindakan lainnya',
      patientInformation: 'Informasi pasien',
      identityDemographics: 'Identitas & demografi',
      contactRelationships: 'Kontak & relasi',
      status: 'Status',
      dateOfBirth: 'Tanggal lahir',
      dobWithAge: '{date} · {age} thn',
      mrn: 'MRN',
      primaryCare: 'Perawatan primer',
      lastVisit: 'Kunjungan terakhir',
      nextVisit: 'Kunjungan berikutnya',
      legalSex: 'Jenis kelamin resmi',
      genderIdentity: 'Identitas gender',
      pronouns: 'Kata ganti',
      race: 'Ras',
      ethnicity: 'Etnisitas',
      preferredLanguage: 'Bahasa pilihan',
      maritalStatus: 'Status perkawinan',
      email: 'Email',
      address: 'Alamat',
      emergencyContact: 'Kontak darurat',
      phone: 'Telepon',
      phoneMobile: 'Ponsel',
      phoneHome: 'Rumah',
      phoneWork: 'Kantor',
      statusActive: 'Aktif',
      statusDeceased: 'Meninggal',
      statusLeftPractice: 'Meninggalkan praktik',
      markDeceased: 'Tandai sebagai meninggal…',
      removeDeceased: 'Hapus status meninggal…',
      markLeftPractice: 'Tandai sebagai meninggalkan praktik…',
      markActive: 'Tandai sebagai aktif…',
      recordUnavailable: 'Rekaman pasien tidak tersedia atau dibatasi.',
      recordLoadError: 'Tidak dapat memuat rekaman pasien.',
    },
    editProfile: {
      description: 'Perbarui identitas, demografi, dan detail kontak {name}.',
      thisPatient: 'pasien ini',
      updated: 'Profil diperbarui.',
      conflict:
        'Profil ini berubah sejak Anda membukanya. Tutup dialog dan buka kembali untuk mengedit versi terbaru.',
      saveFailed: 'Tidak dapat menyimpan: {message}',
      unknownError: 'kesalahan tidak diketahui',
      discardTitle: 'Buang perubahan yang belum disimpan?',
      discardDescription:
        'Perubahan Anda pada profil ini belum disimpan dan akan hilang jika Anda menutup sekarang.',
      discardChanges: 'Buang perubahan',
    },
    status: {
      deceasedSetTitle: 'Tandai {name} sebagai meninggal?',
      deceasedSetDescription:
        'Profilnya akan menampilkan status meninggal. Ini dapat dibatalkan nanti.',
      deceasedSetConfirm: 'Tandai sebagai meninggal',
      deceasedClearTitle: 'Hapus status meninggal untuk {name}?',
      deceasedClearDescription:
        'Profilnya tidak akan lagi menampilkan status meninggal.',
      deceasedClearConfirm: 'Hapus status',
      leftSetTitle: 'Tandai {name} sebagai telah meninggalkan praktik?',
      leftSetDescription:
        'Profilnya akan menunjukkan bahwa mereka telah meninggalkan praktik. Ini dapat dibatalkan nanti.',
      leftSetConfirm: 'Tandai sebagai keluar',
      leftClearTitle: 'Tandai {name} sebagai aktif?',
      leftClearDescription:
        'Profilnya tidak akan lagi menunjukkan bahwa mereka meninggalkan praktik.',
      leftClearConfirm: 'Tandai sebagai aktif',
      updated: 'Status pasien diperbarui.',
      changedElsewhere:
        'Status pasien ini baru saja diubah di tempat lain. Menyegarkan.',
      updateFailed: 'Status pasien tidak dapat diperbarui.',
    },
    medicalProfile: {
      accessEluveAdminLabel: 'Akses penuh',
      accessEluveAdminDetail:
        'Sebagai admin Eluve, Anda dapat melihat rekaman FHIR setiap pasien di semua organisasi.',
      accessTenantAdminLabel: 'Akses penuh di organisasi ini',
      accessTenantAdminDetail:
        'Sebagai admin organisasi, Anda dapat melihat rekaman FHIR setiap pasien di organisasi ini.',
      accessTenantMemberLabel: 'Anda adalah dokter umum untuk pasien ini',
      accessTenantMemberDetail:
        'Itulah sebabnya Anda dapat melihat rekaman ini. Anda hanya akan melihat rekaman FHIR untuk pasien yang mencantumkan Anda sebagai dokter umum.',
      noFhirPatientTitle: 'Tidak ada Pasien FHIR yang terlihat',
      noFhirPatientDescription:
        'Pasien ini belum disinkronkan ke penyimpanan FHIR, atau kebijakan akses Anda memfilternya.',
    },
    careTeam: {
      unnamedPractitioner: 'Praktisi tanpa nama',
      generalPractitioner: 'Dokter Umum',
      name: 'Nama',
      role: 'Peran',
      contact: 'Kontak',
      reference: 'Referensi',
      history: 'Riwayat',
      assignmentHistory: 'Riwayat penugasan',
      assignmentHistoryDescription:
        'Setiap perubahan pada dokter umum pasien ini, diambil dari riwayat sumber daya FHIR.',
      noHistory: 'Tidak ada riwayat yang tersedia.',
      when: 'Waktu',
      change: 'Perubahan',
      gps: 'Dokter',
      version: 'Versi',
      unknownTime: 'Waktu tidak diketahui',
      noGpChanges: 'Tidak ada perubahan dokter umum',
      initialVersion: 'Versi awal',
      noMembers:
        'Tidak ada anggota tim perawatan yang ditugaskan untuk pasien ini.',
    },
    observations: {
      showTrends: 'Tampilkan tren',
      loadingTrends: 'Memuat tren…',
      noneToChart:
        'Belum ada observasi untuk dibuat grafiknya. Ekstrak laporan laboratorium dari tab Unggahan Pasien terlebih dahulu.',
      analyte: 'Analit',
      undated: 'Tanpa tanggal',
      reportFallback: 'Laporan',
    },
    extracted: {
      loading: 'Memuat observasi yang diekstrak…',
      empty:
        'Belum ada observasi yang diekstrak agen. Unggah dokumen dan jalankan agen ekstraksi dari tab Unggahan Pasien.',
      unnamedObservation: 'Observasi tanpa nama',
      laboratoryReport: 'Laporan laboratorium',
      labReportKind: 'Laporan lab',
      extractedRecordKind: 'Rekaman hasil ekstraksi',
      reportDate: 'Laporan {date}',
      extractedDate: 'Diekstrak {date}',
      observationCountOne: '{count} observasi',
      observationCountMany: '{count} observasi',
      needsReview: 'Perlu ditinjau',
      approved: 'Disetujui',
      review: 'Tinjau',
      edit: 'Edit',
      reject: 'Tolak',
      approve: 'Setujui',
      saveAndApprove: 'Simpan & setujui',
      collapseReport: 'Ciutkan laporan',
      expandReport: 'Perluas laporan',
      observationName: 'Nama observasi',
      valuePlaceholder: 'nilai',
      unitPlaceholder: 'satuan',
      referenceRange: 'Rentang referensi',
      refPrefix: 'Ref: {range}',
      approvedToastOne: '{title} disetujui ({count} observasi)',
      approvedToastMany: '{title} disetujui ({count} observasi)',
      rejectedToast: '{title} ditolak',
      approvalFailed: 'Persetujuan gagal: {error}',
      rejectionFailed: 'Penolakan gagal: {error}',
      observationDetails: 'Detail observasi',
      provenance: 'Provenans',
      chainOfEffects: 'Rantai efek',
      onBehalfOf: 'Atas nama',
      agent: 'Agen',
      permissions: 'Izin',
      issued: 'Diterbitkan',
      source: 'Sumber',
      observation: 'Observasi',
      byPublisher: 'oleh {publisher}',
      agentActor: '{agent} (agen)',
      unknownActor: 'tidak diketahui',
    },
    files: {
      untitled: 'Tanpa judul',
      loadFailed: 'Gagal memuat file',
      uploaded: '{name} diunggah',
      uploadFailed: 'Gagal mengunggah {name}',
      extractedPartialOne:
        'Diekstrak {extracted} dari {total} hasil lab — {dropped} tidak dapat distrukturkan dan dihilangkan. Tinjau di Profil Medis → Observasi.',
      extractedPartialMany:
        'Diekstrak {extracted} dari {total} hasil lab — {dropped} tidak dapat distrukturkan dan dihilangkan. Tinjau di Profil Medis → Observasi.',
      extractedSuccessOne:
        'Diekstrak {count} hasil lab. Tinjau di Profil Medis → Observasi.',
      extractedSuccessMany:
        'Diekstrak {count} hasil lab. Tinjau di Profil Medis → Observasi.',
      notLabReport: 'Dokumen ini bukan laporan lab — tidak ada yang diekstrak.',
      noLabResults: 'Tidak ada hasil lab yang ditemukan dalam dokumen ini.',
      reextractionDisabled:
        'Laporan ini sudah ditinjau dan difinalisasi; ekstraksi ulang dinonaktifkan.',
      extractionAlreadyRunning:
        'Ekstraksi untuk dokumen ini sudah berjalan. Harap tunggu hingga selesai.',
      extractionFailedWithError: 'Ekstraksi gagal: {error}',
      extractionFailed: 'Ekstraksi gagal',
      installFailedWithError: 'Instalasi gagal: {error}',
      installFailed: 'Instalasi gagal',
      noDownloadUrl: 'Tidak ada URL unduhan untuk file ini.',
      openFailed: 'Gagal membuka {name}',
      name: 'Nama',
      type: 'Tipe',
      size: 'Ukuran',
      uploadedColumn: 'Diunggah',
      status: 'Status',
      notExtracted: 'Belum diekstrak',
      viewDetails: 'Lihat Detail',
      extract: 'Ekstrak',
      uploadFile: 'Unggah file',
    },
    consent: {
      aiAgent: 'Agen AI',
      unknownPublisher: 'Penerbit tidak diketahui',
      allowTitle: 'Izinkan {name}?',
      builtByEluve: 'Dibuat oleh Eluve',
      builtBy: 'Dibuat oleh {publisher}',
      thirdPartyApp: 'Aplikasi pihak ketiga',
      description:
        'Agen ini berjalan atas nama Anda dan dibatasi hanya pada tindakan yang tercantum di bawah. Agen ini tidak akan pernah dapat membaca atau menulis hal lain.',
      agentCan: 'Agen ini dapat:',
      allow: 'Izinkan',
      publisherLogoAlt: 'Logo {publisher}',
    },
    reviewDoc: {
      title: 'Tinjau hasil ekstraksi',
      loadingDocument: 'Memuat dokumen…',
      displayError: 'Tidak dapat menampilkan dokumen ini.',
      documentFallback: 'Dokumen',
    },
    carePlans: {
      plan: 'Rencana',
      status: 'Status',
      started: 'Dimulai',
      noFhirForList:
        'Tidak ada rekaman FHIR yang terlihat untuk pasien ini, sehingga rencana perawatan tidak dapat ditampilkan.',
      loading: 'Memuat rencana perawatan…',
      loadError: 'Terjadi kesalahan saat memuat rencana perawatan pasien ini.',
      empty: 'Tidak ada rencana perawatan untuk pasien ini.',
      backToList: '← Kembali ke rencana perawatan',
      noFhirForDetail:
        'Tidak ada rekaman FHIR yang terlihat untuk pasien ini, sehingga rencana perawatan ini tidak dapat ditampilkan.',
      loadingOne: 'Memuat rencana perawatan…',
      detailLoadError: 'Rencana perawatan ini tidak dapat dimuat.',
      unknownStart: 'Awal tidak diketahui',
      ongoing: 'berlangsung',
      protocol: 'Protokol',
      conditions: 'Kondisi',
      activities: 'Aktivitas',
      noActivities:
        'Tidak ada aktivitas yang tercatat pada rencana perawatan ini.',
    },
    documents: {
      generatingPdf: 'Membuat PDF...',
      pdfPreviewFailedToast: 'Gagal membuat pratinjau PDF',
      pdfPreviewFailedMessage: 'Gagal membuat pratinjau PDF.',
      titleEmpty: 'Judul tidak boleh kosong.',
      contentEmpty: 'Konten dokumen tidak boleh kosong.',
      saveFailed: 'Gagal menyimpan perubahan',
      documentTitle: 'Judul dokumen',
      markdownTab: 'Markdown',
      pdfTab: 'PDF',
      discardTitle: 'Buang perubahan yang belum disimpan?',
      discardDescription: 'Perubahan Anda akan hilang.',
      discard: 'Buang',
      updated: 'Dokumen diperbarui',
      title: 'Judul',
      type: 'Tipe',
      date: 'Tanggal',
    },
    conditions: {
      header: 'Kondisi',
    },
    labResults: {
      header: 'Hasil Lab',
      name: 'Nama',
      value: 'Nilai',
      referenceRange: 'Rentang Referensi',
      observationsCount: 'Jumlah Observasi',
      outsideReferenceRange: 'Di luar rentang referensi',
      issuedAt: 'Diterbitkan Pada',
    },
    overview: {
      reasonForVisit: 'Alasan kunjungan',
      sourceFallback: 'Sumber',
      situation: 'Situasi',
    },
  },
  appointmentTools: {
    common: {
      close: 'Tutup',
      tryAgain: 'Coba lagi',
      searching: 'Mencari...',
      noResultsFor: 'Tidak ada hasil untuk "{query}"',
      loading: 'Memuat...',
      generatePdfFailed: 'Gagal membuat PDF',
      preparePdfFailed: 'Gagal menyiapkan PDF',
      acceptRecommendationFailed: 'Gagal menerima rekomendasi',
    },
    regenerate: {
      noModelsFound: 'Model tidak ditemukan',
      defaultFromTemplate: 'Bawaan (dari templat)',
    },
    citations: {
      unknownTest: 'Tes Tidak Dikenal',
      normal: 'Normal',
      abnormal: 'Abnormal',
      labResults: 'Hasil Lab',
      testsCount: '{count} tes',
      abnormalCount: '{count} abnormal',
      normalCount: '{count} normal',
      abnormalResults: 'HASIL ABNORMAL',
      normalResults: 'HASIL NORMAL',
      refRange: '(Ref: {range})',
      result: 'HASIL',
      referenceRange: 'RENTANG REFERENSI',
      valueOutsideRange: 'Nilai berada di luar rentang referensi',
      unknownMedication: 'Obat Tidak Dikenal',
      dosageInstructions: 'PETUNJUK DOSIS',
      intent: 'TUJUAN',
      priority: 'PRIORITAS',
      unknownCondition: 'Kondisi Tidak Dikenal',
      codeLabel: 'Kode: {code}',
      clinicalStatus: 'STATUS KLINIS',
      verification: 'VERIFIKASI',
      category: 'KATEGORI',
      note: 'CATATAN',
      patientFallback: 'Pasien',
      dateOfBirth: 'Tanggal Lahir',
      sex: 'Jenis Kelamin',
      email: 'Email',
      phone: 'Telepon',
      address: 'Alamat',
      unknownObservation: 'Observasi Tidak Dikenal',
      value: 'NILAI',
      carePlan: 'Rencana Perawatan',
      description: 'DESKRIPSI',
      goals: 'TUJUAN',
      activities: 'AKTIVITAS',
      clinicalNote: 'Catatan Klinis',
      appointmentLabel: 'Janji temu: {id}',
      noContent: 'Konten tidak tersedia',
      uploadedFile: 'File Terunggah',
      pageSingle: 'Halaman {page}',
      pageRange: 'Halaman {start}-{end}',
      extractedText: 'TEKS TEREKSTRAK',
      intakeForm: 'Formulir Pendaftaran',
      patientLabel: 'Pasien: {name}',
      noFormData: 'Data formulir tidak tersedia',
      noData: 'Data tidak tersedia',
      sourceFallback: 'Sumber',
      unnamedArtifact: 'Artefak Tanpa Nama',
      loadingArtifact: 'Memuat artefak...',
      errorLoadingArtifacts: 'Gagal memuat artefak: {message}',
      sourceNotFound: 'Dokumen sumber yang memuat kutipan ini tidak ditemukan.',
      fetchedArtifacts: 'Mengambil {count} artefak.',
      sources: 'Sumber:',
    },
    documents: {
      createTemplateTitle: 'Buat templat',
      editTemplateTitle: 'Edit templat',
      createDocumentTitle: 'Buat Dokumen atau Surat',
      createDocumentSubtitle:
        'Mulai dari salah satu templat Anda, atau buat yang baru. Eluve mengisinya dari catatan ini — simpan, kirim lewat email, atau cetak.',
      generateWithAi: 'Buat dengan AI',
      generateWithAiHint:
        'Jelaskan dokumen yang Anda inginkan — misalnya, “surat rujukan ke dokter jantung yang mencantumkan nyeri dada dan riwayat pasien.”',
      promptPlaceholder: 'Jelaskan dokumennya…',
      generating: 'Membuat…',
      generate: 'Buat',
      templates: 'Templat',
      searchTemplates: 'Cari templat…',
      createNewTemplate: 'Buat templat baru',
      createNewTemplateHint:
        'Jelaskan dengan AI untuk membuat dokumen dari catatan Anda',
      noTemplates: 'Tidak ada templat tersedia',
      createdByYou: 'Dibuat oleh Anda',
      createdByEluve: 'Dibuat oleh Eluve',
      prebuilt: 'Bawaan',
      fillPdfTitle: 'Isi PDF',
      fillPdfSubtitle:
        'Pilih templat PDF yang dapat diisi atau unggah yang baru. Eluve mengisi kolom dari catatan ini.',
      createPdfTemplate: 'Buat templat formulir PDF baru',
      createPdfTemplateHint:
        'Taruh PDF statis apa pun — Eluve mendeteksi atau menambahkan kolom yang dapat diisi',
      noPdfTemplates: 'Belum ada templat PDF',
      yourPdfTemplates: 'Templat PDF Anda',
      eluveTemplates: 'Templat Eluve',
      dropPdfHere: 'Taruh PDF Anda di sini',
      clickToBrowse:
        'Klik untuk menelusuri, atau seret dan taruh PDF Anda di sini',
      pdfOnlyMax: 'Hanya PDF, maks 10 MB',
      enterTemplateName: 'Masukkan nama templat',
      enterTemplateContent: 'Masukkan isi templat',
      templateUpdated: 'Templat diperbarui',
      templateCreated: 'Templat dibuat',
      updateTemplateFailed: 'Gagal memperbarui templat',
      createTemplateFailed: 'Gagal membuat templat',
      onlyPdfAllowed: 'Hanya file PDF yang diizinkan',
      fileTooLarge: 'Ukuran file harus kurang dari 10 MB',
      unableToDetermineTenant: 'Tidak dapat menentukan organisasi',
      somethingWentWrong: 'Terjadi kesalahan',
      templateGenerationFailed: 'Pembuatan templat gagal: {message}',
      backToTemplates: 'Kembali ke templat',
      createTemplateSubtitle:
        'Buat dari perintah AI — jelaskan dokumen yang harus dihasilkan templat ini. Misalnya, “surat rujukan ke dokter jantung yang mencantumkan nyeri dada dan riwayat pasien.”',
      renamePdfTemplate: 'Ganti nama templat formulir PDF ini.',
      updateTemplateContent: 'Perbarui isi dan nama templat Anda.',
      and: 'DAN',
      addExample: 'Tambahkan contoh sebagai titik awal (opsional)',
      addExampleHint:
        'Unggah dokumen contoh — Eluve mengubahnya menjadi isi templat dan menambahkannya ke apa yang sudah Anda tulis.',
      uploadingFile: 'Mengunggah {fileName}...',
      fileFallback: 'file',
      generatingFromDocument: 'Membuat templat dari dokumen...',
      templateName: 'Nama templat',
      required: 'Wajib diisi',
      namePlaceholder: 'Beri nama templat Anda',
      saving: 'Menyimpan...',
      save: 'Simpan',
      saveTemplateFailed: 'Gagal menyimpan templat',
      readingLayout:
        'Eluve sedang membaca tata letak dan menambahkan kolom formulir…',
      detectingLabels: 'Mendeteksi label, kotak centang, dan area tanda tangan',
      tryAnotherFile: 'Coba file lain',
      back: 'Kembali',
      createPdfTemplateTitle: 'Buat templat formulir PDF',
      createPdfTemplateSubtitle:
        'Unggah PDF statis. Eluve memeriksa kolom yang dapat diisi dan menambahkannya dengan AI jika perlu.',
      fieldsCountOne: '{count} kolom',
      fieldsCountMany: '{count} kolom',
      formFieldsCountOne: '{count} kolom formulir',
      formFieldsCountMany: '{count} kolom formulir',
      alreadyFillableForm:
        '{fileName} sudah merupakan formulir yang dapat diisi · {fields}',
      addedFields:
        'Eluve menambahkan {fields} ke {fileName}. Tinjau, lalu simpan sebagai templat.',
      detectedFields: 'KOLOM TERDETEKSI · {count}',
      saveAsTemplate: 'Simpan sebagai templat',
      templateSaved: 'Templat disimpan',
      templateSavedHint:
        '"{name}" sekarang ada di templat PDF Anda. Isi dari catatan ini sekarang, atau kapan saja nanti.',
      done: 'Selesai',
      fillFromNote: 'Isi dari catatan ini →',
      fillableForm: 'Formulir yang dapat diisi',
      use: 'Gunakan',
      templateOptions: 'Opsi templat',
      edit: 'Edit',
      delete: 'Hapus',
      deleteTemplateTitle: 'Hapus templat ini?',
      deleteTemplateDescription: 'Templat {name} akan dihapus secara permanen.',
      deleting: 'Menghapus...',
      createDocument: 'Buat Dokumen',
      create: 'Buat',
      fillPdfMenuHint: 'Eluve mengisi PDF yang dapat diisi dari catatan ini',
      createDocOrLetter: 'Buat dokumen atau surat',
      createDocOrLetterHint:
        'Buat teks untuk dikirim lewat email, disimpan, atau dicetak',
      templateDeleted: 'Templat dihapus',
      deleteTemplateFailed: 'Gagal menghapus templat',
      generateError: 'Terjadi kesalahan saat membuat dokumen ini.',
      preparingDocument: 'Menyiapkan dokumen Anda',
      docFromSession: 'Dokumen ini akan dibuat dari data sesi Anda.',
      switchTabsHint:
        'Sementara itu Anda dapat berpindah tab — kami akan terus bekerja di latar belakang.',
      stopGenerating: 'Hentikan pembuatan',
      saveChangesFailed: 'Gagal menyimpan perubahan',
      copiedToClipboard: 'Disalin ke papan klip',
      copyFailed: 'Gagal menyalin',
      pdfDownloaded: 'PDF diunduh',
      emailClipboardFallback:
        'Dokumen disalin ke papan klip — tempel ke email Anda',
      copied: 'Disalin',
      copy: 'Salin',
      export: 'Ekspor',
      downloadPdf: 'Unduh PDF',
      emailDocument: 'Kirim Dokumen lewat Email',
      pdfLoadFailed: 'Tidak dapat memuat PDF ini.',
      preparingPdf: 'Menyiapkan PDF Anda',
      pdfFromSession: 'Formulir PDF ini akan diisi menggunakan data sesi Anda.',
      preparingPdfButton: 'Menyiapkan PDF…',
      fillError: 'Terjadi kesalahan saat mengisi formulir ini.',
      prevPage: '← Sebelumnya',
      nextPage: 'Berikutnya →',
      pageOf: 'Halaman {page} dari {total}',
      previewFailed: 'Tidak dapat menampilkan pratinjau PDF ini.',
      download: 'Unduh',
      moreFields: '+{count} lagi',
      skippedFieldsOne:
        '{count} kolom tidak dapat diisi otomatis — tinjau sebelum digunakan: {fields}',
      skippedFieldsMany:
        '{count} kolom tidak dapat diisi otomatis — tinjau sebelum digunakan: {fields}',
      alteredFieldsOne:
        '{count} kolom disesuaikan agar pas dengan formulir (karakter atau panjang tidak didukung) — tinjau: {fields}',
      alteredFieldsMany:
        '{count} kolom disesuaikan agar pas dengan formulir (karakter atau panjang tidak didukung) — tinjau: {fields}',
      appearanceFallback:
        'PDF ini disimpan dengan mode kompatibilitas — beberapa penampil mungkin menampilkan kolom secara berbeda. Tinjau sebelum mengirim.',
      humanOnlyFieldsOne:
        '{count} kolom sengaja dibiarkan untuk diisi manual (tanda tangan, persetujuan, dll.)',
      humanOnlyFieldsMany:
        '{count} kolom sengaja dibiarkan untuk diisi manual (tanda tangan, persetujuan, dll.)',
    },
    tabs: {
      note: 'Catatan',
      carePlan: 'Rencana Perawatan',
      deleteDocAria: 'Hapus {title}',
      deleteDocumentTitle: 'Hapus dokumen?',
      deleteDocumentDescription:
        'Ini akan menghapus “{title}” secara permanen. Tindakan ini tidak dapat dibatalkan.',
    },
    billing: {
      addBillingCode: 'Tambah Kode Penagihan',
      updatePriceFailed: 'Kami tidak dapat memperbarui harga.',
      revertChanges: 'Batalkan perubahan',
      removeCode: 'Hapus kode',
      removeBillingCodeFailed: 'Kami tidak dapat menghapus kode penagihan.',
      addBillingCodeFailed: 'Kami tidak dapat menambahkan kode penagihan.',
      noBillingCodesAdded: 'Belum ada kode penagihan yang ditambahkan.',
      modifiersHint: 'Daftar modifier yang dipisahkan koma.',
      editModifiers: 'Edit modifier',
      updateModifiers: 'Perbarui Modifier',
      editPrice: 'Edit harga',
      updatePrice: 'Perbarui Harga',
      billingDetails: 'Detail Penagihan',
      noIcdCodes: 'Belum ada kode ICD yang ditambahkan di atas.',
      updateSuperbill: 'Perbarui Superbill',
      generateSuperbill: 'Buat Superbill',
      billingCodesHeading: 'Kode Penagihan',
      cptCopyrightLine1: 'CPT hak cipta 2025 American Medical Association.',
      cptCopyrightLine2: 'Semua hak dilindungi.',
      addAmendments: 'Tambah Amendemen',
      noBillingCodes: 'Tidak ada kode penagihan.',
      recommendedCodes: 'Kode yang Direkomendasikan',
      generateRecommendedCodes: 'Buat Kode yang Direkomendasikan',
      generatingRecommendations: 'Membuat rekomendasi...',
      generateRecommendationsFailed:
        'Gagal membuat rekomendasi kode penagihan. Silakan coba lagi nanti.',
      addAmendmentFailed: 'Gagal menambahkan amendemen kode penagihan',
      billingCodesFeedback: 'Apakah kode penagihan ini membantu?',
      deleteAmendmentFailed: 'Gagal menghapus amendemen kode penagihan',
      updateModifiersFailed: 'Kami tidak dapat memperbarui modifier.',
      updateQuantityFailed: 'Kami tidak dapat memperbarui jumlah.',
      selectIcdFailed: 'Kami tidak dapat memilih kode ICD.',
      deselectIcdFailed: 'Kami tidak dapat membatalkan pilihan kode ICD.',
      removeCodeFailed: 'Gagal menghapus kode penagihan',
      addCodeFailed: 'Gagal menambahkan kode penagihan',
      codeToRemoveNotFound: 'Kode penagihan yang akan dihapus tidak ditemukan',
      searchBillingCodes: 'Cari kode penagihan',
      chooseCodePlaceholder: 'Pilih kode yang ingin Anda tambahkan',
      enterCodeOrSearchTerm: 'Masukkan kode atau kata kunci pencarian',
      chooseDiagnosis: 'Pilih diagnosis',
      searchDiagnosis: 'Cari diagnosis',
      superbill: 'Superbill',
    },
    medicine: {
      orderDetails: 'Detail Pesanan',
      doseLabel: 'Dosis *',
      dosePlaceholder: 'mis., 10 mg',
      frequencyLabel: 'Frekuensi *',
      selectFrequency: 'Pilih frekuensi',
      routeLabel: 'Rute *',
      selectRoute: 'Pilih rute',
      durationLabel: 'Durasi',
      durationPlaceholder: 'mis., 30 hari',
      quantityLabel: 'Jumlah yang Diberikan *',
      refillsLabel: 'Isi Ulang yang Diizinkan',
      additionalInstructions: 'Petunjuk Tambahan',
      instructionsPlaceholder:
        'mis., minum bersama makanan, hindari alkohol...',
      updateOrder: 'Perbarui Pesanan',
      addToOrders: 'Tambahkan ke Pesanan',
      medicationOrders: 'Pesanan Obat',
      searchMedications: 'Cari obat...',
      noMedicationsFound: 'Tidak ada obat yang ditemukan untuk "{query}"',
      newOrder: 'Pesanan Baru: {name}',
      currentOrders: 'Pesanan Saat Ini',
      takeInstruction: 'Konsumsi {dose} {route}, {frequency}',
      viewPdf: 'Lihat PDF',
      sendToPharmacy: 'Kirim ke Apotek',
      orderSentAt: 'Pesanan dikirim ke apotek pukul {time}',
      ordersSentSuccess: 'Pesanan berhasil dikirim ke apotek',
      quickActions: 'Tindakan Cepat',
      emptyOrders:
        'Belum ada pesanan obat. Cari obat atau tinjau rekomendasi AI di atas.',
      addOrderFailed: 'Gagal menambahkan pesanan obat',
      removeMedicationFailed: 'Gagal menghapus obat',
      updateOrderFailed: 'Gagal memperbarui pesanan obat',
      recommendationsFeedback: 'Apakah rekomendasi obat ini membantu?',
      removeMedicineFailed: 'Gagal menghapus obat',
      medication: 'Obat',
      recommendedMedication: 'Obat yang Direkomendasikan',
      medicationsFeedback: 'Apakah obat-obatan ini membantu?',
      typeMedicineName: 'Ketik nama obat dan tekan Enter untuk mencari',
      noMedicinesFound: 'Obat tidak ditemukan',
      chooseMedicine: 'Pilih obat yang ingin Anda tambahkan',
      searchMedicineInventory: 'Cari inventaris obat',
    },
    referrals: {
      referralSent: 'Rujukan dikirim ke {name}',
      referTo: 'Rujuk ke {name}',
      specialistInformation: 'Informasi Spesialis',
      referralLetter: 'Surat Rujukan',
      printPdf: 'Cetak PDF',
      sendReferral: 'Kirim Rujukan',
      referToSpecialist: 'Rujuk ke Spesialis',
      searchSpecialists: 'Cari spesialis berdasarkan nama atau spesialisasi...',
      moreResults: '{count} hasil lagi — persempit pencarian Anda',
      noSpecialistsFound: 'Tidak ada spesialis yang ditemukan untuk "{query}"',
    },
    outputs: {
      billingCodeRecommendations: 'Rekomendasi Kode Penagihan',
      editDiagnosis: 'Edit diagnosis ini',
      removeDiagnosis: 'Hapus diagnosis ini',
      justificationLabel: 'Justifikasi:',
      excerptLabel: 'Kutipan:',
      urgencyHigh: 'Urgensi: Tinggi',
      supportingEvidence: 'BUKTI PENDUKUNG',
      differentialGap: 'KESENJANGAN DIFERENSIAL',
      keyUncertainty: 'KETIDAKPASTIAN UTAMA',
      suggestedNextSteps: 'LANGKAH SELANJUTNYA YANG DISARANKAN',
      sourcesCaption: 'SUMBER',
      insightHelpful: 'Apakah wawasan ini membantu?',
      analyzingDiagnosis: 'Menganalisis diagnosis...',
      underConsideration: 'Dalam Pertimbangan',
      mostLikely: 'PALING MUNGKIN',
      moderateSignal: 'SINYAL SEDANG',
      weakSignal: 'SINYAL LEMAH',
      generateOutputFailed: 'Gagal membuat output. Silakan coba lagi nanti.',
      noOutputAvailable: 'Output Tidak Tersedia',
      outputProblem: 'Terjadi masalah saat membuat output ini',
      generatingOutput: 'Membuat Output',
      pfshTitle: 'Riwayat Dahulu, Keluarga, dan Sosial (PFSH)',
      allergies: 'Alergi',
      medications: 'Obat-obatan',
      existingConditions: 'Kondisi yang Ada',
      surgeries: 'Operasi',
      socialHistory: 'Riwayat Sosial',
      familyHistory: 'Riwayat Keluarga',
    },
    templateSelector: {
      loadingTemplates: 'Memuat Templat...',
      defaultBundle: 'Bawaan - {name}',
      selectTemplate: 'Pilih Templat',
      updateBundleFailed: 'Tidak dapat memperbarui paket templat',
      templateLabel: 'Templat',
      defaultForOrg: 'Bawaan untuk organisasi Anda',
    },
    sessionType: {
      updateFailed: 'Gagal memperbarui jenis sesi',
      noneAvailable: 'Tidak ada yang tersedia',
      noType: 'Tanpa Jenis',
      searchTypes: 'Cari jenis...',
    },
    page: {
      loadingAppointment: 'Memuat Janji Temu...',
      canceledInEhr: 'Janji temu ini dibatalkan di EHR Anda.',
      viewExternalChart: 'Lihat Rekam Medis Eksternal',
    },
    transcription: {
      analyzingAudio: 'Menganalisis audio',
      analyzingAudioDescription:
        'Menganalisis audio untuk meningkatkan akurasi. Tersisa ({count}) file.',
    },
    chartsExport: {
      downloadFailedOne: '{count} janji temu tidak dapat diunduh',
      downloadFailedMany: '{count} janji temu tidak dapat diunduh',
      notExportedOne: '{count} janji temu berikut tidak dapat diekspor:',
      notExportedMany: '{count} janji temu berikut tidak dapat diekspor:',
      cantExportDefault:
        'Janji temu yang Anda pilih tidak dapat diekspor. Pastikan janji temu memiliki resume yang tersedia.',
      cantExportTitle: 'Janji temu tidak dapat diekspor ke PDF',
      preparingDownload: 'Menyiapkan unduhan',
      downloadingChartsCount: 'Mengunduh {count} rekam medis',
      downloadingCharts: 'Mengunduh rekam medis',
      downloadComplete: 'Unduhan selesai',
      chartsDownloadedOne: '{count} rekam medis diunduh',
      chartsDownloadedMany: '{count} rekam medis diunduh',
      downloadChartsAsPdf: 'Unduh Rekam Medis sebagai PDF',
      noSummariesTooltip:
        'Janji temu yang dipilih tidak memiliki resume yang tersedia',
    },
    appointmentsTable: {
      selectAllAria: 'Pilih semua',
      selectRowAria: 'Pilih baris',
      locationFilter: 'Lokasi',
      statusFilter: 'Status',
      userFilter: 'Pengguna',
      startDateFilter: 'Tanggal Mulai',
      youSuffix: '{name} (Anda)',
      selectAllPrefix: 'Semua',
      selectAllSuffix:
        'janji temu di halaman ini dipilih. Pilih semua {count} janji temu yang difilter?',
      allFilteredSelectedSuffix: 'janji temu yang difilter dipilih.',
      selectAll: 'Pilih Semua',
      clearSelection: 'Hapus Pilihan',
      selectedCount: '{count} dipilih',
      onlyMyAppointments: 'Hanya janji temu saya',
    },
  },
  outputTemplates: {
    common: {
      templates: 'Templat',
      createTemplate: 'Buat Templat',
      noCreatePermission:
        'Anda tidak memiliki izin untuk membuat templat. Silakan hubungi administrator organisasi Anda.',
      backToTemplates: 'Kembali ke templat',
      saving: 'Menyimpan…',
      saveDraft: 'Simpan Draf',
      nameRequired: 'Beri nama templat terlebih dahulu',
      draftSaved: 'Draf disimpan',
      somethingWentWrong: 'Terjadi kesalahan',
      generationFailed: 'Gagal membuat templat: {message}',
      generating: 'Membuat…',
      generate: 'Buat',
      preview: 'Pratinjau',
      templateCreated: 'Templat dibuat',
      createTemplateFailed: 'Gagal membuat templat',
    },
    generateWithAi: {
      title: 'Buat dengan AI',
      intro:
        'Ceritakan tentang praktik Anda dan kami akan merancang templat sesuai cara Anda bekerja.',
      noteFormatLabel: 'Format catatan',
      noteLengthLabel: 'Panjang catatan',
      specialtyLabel: 'Spesialisasi',
      visitTypeLabel: 'Jenis kunjungan (opsional)',
      instructionsLabel: 'Instruksi tambahan (opsional)',
      specialtyPlaceholder: 'Pilih atau ketik spesialisasi Anda',
      visitTypePlaceholder: 'Pilih atau ketik jenis kunjungan',
      instructionsPlaceholder:
        'Apa pun yang perlu memengaruhi catatan — bagian yang selalu Anda sertakan, gaya bahasa, persyaratan penjamin…',
      popularKeywords: 'Kata kunci populer',
      designing: 'Merancang templat Anda…',
      searchOrType: 'Cari atau ketik sendiri…',
      useTypedValue: 'Gunakan “{value}”',
      failedToGenerate: 'Gagal membuat templat',
      unableToGenerate: 'Tidak dapat membuat templat dari permintaan ini.',
      formatSoapExpansion: 'Subjektif · Objektif · Asesmen · Rencana',
      formatSoapDescription:
        'Catatan klinis standar untuk sebagian besar kunjungan medis.',
      formatBirpExpansion: 'Perilaku · Intervensi · Respons · Rencana',
      formatBirpDescription:
        'Berfokus pada perilaku yang diamati dan intervensi Anda — umum di kesehatan perilaku.',
      formatDapExpansion: 'Data · Asesmen · Rencana',
      formatDapDescription:
        'Catatan ringkas yang menggabungkan semua hasil pengamatan dalam satu bagian data.',
      formatGirpExpansion: 'Tujuan · Intervensi · Respons · Rencana',
      formatGirpDescription:
        'Diawali dengan tujuan rencana perawatan — cocok untuk program terapi berbasis tujuan.',
      lengthConciseLabel: 'Ringkas',
      lengthConciseDescription:
        'Hanya bagian inti, dengan panduan singkat di setiap bagian.',
      lengthBalancedLabel: 'Seimbang',
      lengthBalancedDescription:
        'Bagian inti dengan struktur sedang di setiap bagian.',
      lengthDetailedLabel: 'Terperinci',
      lengthDetailedDescription:
        'Bagian inti dengan panduan menyeluruh dan spesifik spesialisasi di setiap bagian.',
    },
    workspace: {
      previewEmptyState: 'Lihat seperti apa catatan dari templat ini',
      generatePreview: 'Buat Pratinjau',
      templateNameLabel: 'Nama Templat',
      templateNamePlaceholder: 'mis. Catatan SOAP Penyakit Dalam',
      addSection: 'Tambah bagian',
      addGroup: 'Tambah grup',
      additionalSettings: 'Pengaturan tambahan',
      templateDescriptionLabel: 'Deskripsi templat',
      templateDescriptionPlaceholder:
        'Jelaskan kapan templat ini sebaiknya digunakan…',
      allowGroups: 'Izinkan grup',
      allowGroupsDescription:
        'Kelompokkan bagian yang berkaitan di bawah satu nama bersama. Grup dipindahkan sebagai satu kesatuan, dan bagian dapat diseret masuk dan keluar darinya.',
      customTranscriptOption: 'Transkrip kustom…',
      editCustomTranscript: 'Edit transkrip kustom',
      generatePreviewTooltip: 'Buat pratinjau',
      regeneratePreviewTooltip: 'Buat ulang pratinjau',
      generatePreviewFailed: 'Gagal membuat pratinjau',
      customTranscriptTitle: 'Transkrip kustom',
      customTranscriptDescription:
        'Tempel transkrip kunjungan untuk menguji templat ini.',
      customTranscriptPlaceholder: 'Tempel transkrip di sini…',
      useTranscript: 'Gunakan transkrip',
      modelLabel: 'Model',
      generatedIn: 'Dibuat dalam {duration}',
      tokenBreakdown: '{input} input · {output} output',
      tokenCount: '{count} token',
      editSection: 'Edit bagian',
    },
    wizard: {
      title: 'Buat templat',
      subtitle: 'Bagaimana Anda ingin memulai?',
      aiModeDescription:
        'Jelaskan catatan yang Anda inginkan dan kami akan menyusun templatnya.',
      uploadModeTitle: 'Unggah atau impor catatan yang sudah ada',
      uploadModeDescription:
        'Unggah atau tempel catatan lama dan kami akan menyesuaikan strukturnya.',
      manualModeTitle: 'Mulai dari awal',
      manualModeDescription: 'Susun templat Anda bagian demi bagian.',
      orStartFromScratch: 'atau mulai dari awal',
      back: 'Kembali',
      uploadStepDescription:
        'Unggah catatan lama — atau tempelkan — dan kami akan menyesuaikan strukturnya untuk menyusun templat Anda.',
      onlyPdfSupported: 'Hanya berkas PDF yang didukung.',
      fileTooLarge: 'Ukuran berkas harus kurang dari 10 MB.',
      prepareUploadFailed: 'Gagal menyiapkan unggahan berkas',
      uploadFailed: 'Gagal mengunggah berkas',
      failedToGenerateFromNote: 'Gagal membuat templat dari catatan ini',
      unableToGenerateFromNote: 'Tidak dapat membuat templat dari catatan ini.',
      uploadingFile: 'Mengunggah {fileName}…',
      fileFallback: 'berkas',
      analyzingNote: 'Menganalisis catatan Anda dan menyusun templat…',
      dropZoneHint:
        'Seret dan letakkan PDF di sini, atau klik untuk menelusuri',
      dropZoneLimit: 'Hanya PDF, maks. 10 MB',
      removeFile: 'Hapus berkas',
      orDivider: 'ATAU',
      pasteNotePlaceholder: 'Tempel teks lengkap catatan yang sudah ada…',
      removeFileToPaste:
        'Hapus berkas yang diunggah untuk menempel catatan sebagai gantinya.',
    },
    edit: {
      title: 'Edit Templat',
      disabledForOrg: 'Dinonaktifkan untuk organisasi',
      enabledForOrg: 'Diaktifkan untuk organisasi',
      updateAvailabilityFailed: 'Gagal memperbarui ketersediaan',
      versionPublished: 'Versi diterbitkan',
      newerVersionActive: 'Versi yang lebih baru sudah aktif',
      saveFailed: 'Gagal menyimpan',
      savedCopy: 'Salinan disimpan',
      saveCopyFailed: 'Gagal menyimpan salinan',
      copyOf: 'Salinan {name}',
      untitled: 'Tanpa judul',
      versionNowActive: 'Versi {number} sekarang aktif',
      setActiveVersionFailed: 'Gagal menetapkan versi aktif',
      moreActions: 'Tindakan lainnya',
      setAsActive: 'Tetapkan sebagai Aktif',
      enabledForOrganizationItem: 'Diaktifkan untuk Organisasi',
      saveACopy: 'Simpan Salinan',
      templateVersionAria: 'Versi templat',
      versionItemActive: 'Versi {number} · Aktif',
      versionItemDraft: 'Versi {number} · Draf',
      versionItemInactive: 'Versi {number} · Tidak aktif',
      publishVersion: 'Terbitkan Versi',
      editDraft: 'Edit Draf',
      creating: 'Membuat…',
      createDraft: 'Buat Draf',
      templateNotFound: 'Templat tidak ditemukan.',
      unsupportedBlocks:
        'Templat ini menggunakan blok lanjutan yang belum dapat ditampilkan editor ini, sehingga penyimpanan dinonaktifkan — menyimpan ulang di sini akan menghapus blok tersebut.',
      readOnlyEluvePrefix:
        'Templat ini disediakan oleh Eluve dan tidak dapat diubah di sini. Silakan jelajahi dan sesuaikan — gunakan ',
      readOnlyMemberPrefix:
        'Templat ini dimiliki oleh anggota lain, sehingga tidak dapat diubah di sini. Gunakan ',
      saveACopyInline: 'Simpan salinan',
      readOnlySuffix:
        ' untuk membuat versi Anda sendiri yang dapat diedit untuk organisasi ini.',
      adminEditingOthers:
        'Anda sedang mengedit templat milik anggota lain. Sebagai admin Anda dapat menerbitkan perubahan — templat tetap menjadi milik mereka.',
    },
    new: {
      title: 'Templat Baru',
      saveDraft: 'Simpan draf',
      saveTemplate: 'Simpan templat',
      templateSaved: 'Templat disimpan',
      saveFailed: 'Gagal menyimpan templat',
    },
    details: {
      setDefaultFailed: 'Varian tidak dapat ditetapkan sebagai default.',
      updateFailed: 'Templat tidak dapat diperbarui.',
      updateNotesFailed: 'Catatan varian tidak dapat diperbarui.',
      variantJsonCopied: 'JSON varian disalin ke clipboard.',
      variantJsonCopyFailed: 'JSON varian tidak dapat disalin.',
      jsonSchemaCopied: 'Skema JSON disalin ke clipboard.',
      jsonSchemaCopyFailed: 'Skema JSON tidak dapat disalin.',
      templateNamePlaceholder: 'Nama templat',
      templateDescriptionPlaceholder: 'Deskripsi templat',
      variants: 'Varian',
      export: 'Ekspor',
      variantJson: 'JSON Varian',
      viewJsonSchema: 'Lihat Skema JSON',
      jsonSchemaTitle: 'Skema JSON Templat Output',
      variantNotes: 'Catatan Varian',
      noNotes: 'Tidak ada catatan.',
    },
    bundlesList: {
      draftTooltip: 'Anda memiliki draf templat ini yang belum diterbitkan.',
      draft: 'Draf',
      readOnlyTooltip:
        'Disediakan oleh Eluve — templat ini tidak dapat diedit.',
      readOnly: 'Hanya baca',
      disabledTooltip:
        'Templat ini dinonaktifkan untuk organisasi Anda, sehingga tidak akan tersedia saat membuat catatan.',
      disabled: 'Dinonaktifkan',
      noDescription: 'Belum ada deskripsi.',
      searchPlaceholder: 'Cari templat…',
      showOnlyMine: 'Tampilkan hanya templat organisasi saya',
      emptyState: 'Belum ada templat — buat templat pertama Anda.',
      noMatches: 'Tidak ada templat yang cocok dengan filter Anda.',
    },
    legacyList: {
      nameHeader: 'Nama',
      sourceHeader: 'Sumber',
      descriptionHeader: 'Deskripsi',
      createdAtHeader: 'Dibuat Pada',
      statusHeader: 'Status',
      variantCountHeader: 'Jumlah Varian',
      draft: 'Draf',
      submitted: 'Dikirim',
    },
    generateDialog: {
      title: 'Buat Templat dengan AI',
      description:
        'Buat templat dokumen medis baru berdasarkan kebutuhan Anda.',
      documentDescriptionRequired: 'Deskripsi dokumen wajib diisi',
      documentDescriptionLabel: 'Deskripsi Dokumen',
      requiredIndicator: '(Wajib)',
      documentDescriptionPlaceholder:
        'Jelaskan format dokumen medis, termasuk bagian, kolom, dan persyaratan struktur...',
      typeLabel: 'Jenis',
      typePlaceholder:
        'mis., "catatan klinis", "laporan lab", "ringkasan pulang"',
      requiredFieldsLabel: 'Kolom Wajib',
      requiredFieldsPlaceholder:
        'Daftar dipisahkan koma: keluhan utama, asesmen, rencana',
      constraintsLabel: 'Instruksi Tambahan',
      constraintsPlaceholder:
        'Aturan validasi, persyaratan format, atau batasan tertentu...',
      exampleDocumentLabel: 'Contoh Dokumen (PDF)',
      beta: 'Beta',
      pdfDocumentAria: 'Dokumen PDF',
      pdfUploaded: 'PDF berhasil diunggah',
      uploadingPdf: 'Mengunggah PDF...',
      generateTemplate: 'Buat Templat',
      onlyPdfAllowed: 'Hanya berkas PDF yang diizinkan',
      fileTooLarge: 'Ukuran berkas harus kurang dari 10 MB',
      invalidExtension: 'Ekstensi berkas tidak valid',
      uploadPdfFailed: 'Gagal mengunggah berkas PDF',
      pdfUploadSuccess: 'Berkas PDF berhasil diunggah',
      generatedSuccess: 'Templat output berhasil dibuat!',
      generateFailed: 'Gagal membuat templat',
      generateOutputFailed: 'Gagal membuat templat output',
    },
    prefill: {
      title: 'Isi otomatis templat Anda',
      importJson: 'Impor JSON',
      pastePlaceholder: 'Tempel JSON yang diekspor di sini',
      import: 'Impor',
      invalidJsonStructure:
        'Format JSON tidak valid. Diharapkan struktur templat hasil ekspor.',
      importSuccess: 'Skema JSON berhasil diimpor',
      invalidJson: 'Format JSON tidak valid. Silakan periksa input Anda.',
    },
    preview: {
      promptTemplateRequired: 'Templat prompt wajib diisi',
      invalidUuid: 'Harus berupa UUID yang valid',
      outputLanguageRequired: 'Bahasa output wajib diisi',
      noTemplateAvailable: 'Tidak ada templat yang tersedia untuk pembuatan',
      generateNoteFailed: 'Gagal membuat catatan',
      provideTranscriptBy: 'Untuk membuat catatan, sediakan transkrip dengan:',
      chooseSampleTranscript: 'Memilih contoh transkrip',
      provideAppointmentId: 'Memberikan ID janji temu',
      appointmentIdLabel: 'ID Janji Temu',
      transcriptLabel: 'Transkrip',
      transcriptPlaceholder: 'Tempel contoh transkrip',
      orChooseSample: 'Atau pilih contoh transkrip:',
      promptTemplateLabel: 'Templat Prompt',
      outputLanguageLabel: 'Bahasa Output',
      regenerateNote: 'Buat Ulang Catatan',
      generateNote: 'Buat Catatan',
      hideDetails: 'Sembunyikan detail',
      showDetails: 'Tampilkan detail',
      previewTemplateTab: 'Pratinjau Templat',
    },
    variant: {
      title: 'Buat Varian Templat',
      createFailed: 'Gagal membuat templat output',
    },
    headerButtons: {
      deleteDraft: 'Hapus Draf',
      submitTemplate: 'Kirim Templat',
    },
    unsavedChanges: {
      title: 'Buang perubahan yang belum disimpan?',
      description:
        'Anda memiliki perubahan yang belum disimpan pada templat ini. Jika keluar sekarang, perubahan akan hilang.',
      keepEditing: 'Lanjutkan mengedit',
      discard: 'Buang perubahan',
    },
    editor: {
      sectionTitlePlaceholder: 'Judul bagian',
      groupNamePlaceholder: 'Nama grup',
      sectionBodyPlaceholder:
        'Jelaskan hasil yang diharapkan untuk bagian ini…',
      dragToReorderSection: 'Seret untuk mengurutkan ulang bagian',
      dragToReorderGroup: 'Seret untuk mengurutkan ulang grup',
      required: 'Wajib',
    },
    bubbleMenu: {
      generateUsingAi: 'Buat dengan AI',
      writeManually: 'Tulis manual',
      ungroup: 'Pisahkan grup',
      deleteSection: 'Hapus bagian',
      deleteGroupAria: 'Hapus grup beserta bagiannya',
      moveSectionUp: 'Pindahkan bagian ke atas',
      moveSectionDown: 'Pindahkan bagian ke bawah',
      moveGroupUp: 'Pindahkan grup ke atas',
      moveGroupDown: 'Pindahkan grup ke bawah',
      heading: 'Judul',
      subheading: 'Subjudul',
      normalText: 'Teks normal',
      bold: 'Tebal',
      italic: 'Miring',
      bulletList: 'Daftar poin',
      numberedList: 'Daftar bernomor',
    },
    progress: {
      openingReadingTranscript: 'Membaca transkrip…',
      openingIdentifyingSpeakers: 'Mengidentifikasi siapa mengatakan apa…',
      openingGatheringFacts: 'Mengumpulkan fakta yang relevan secara medis…',
      genericCrossCheckingSymptoms: 'Mencocokkan gejala dengan riwayat…',
      genericExtractingMedications: 'Mengekstrak nama obat dan dosis…',
      genericNotingNegatives: 'Mencatat temuan negatif yang relevan…',
      genericFlaggingFollowUps:
        'Menandai hal tindak lanjut yang disebut dalam kunjungan…',
      genericSeparatingDetails:
        'Memisahkan keterangan pasien dari temuan klinis…',
      genericCheckingAllergies: 'Memeriksa alergi dan kontraindikasi…',
      genericListeningForTiming: 'Menyimak petunjuk waktu dan durasi…',
      genericMatchingComplaints:
        'Mencocokkan keluhan dengan bagian yang relevan…',
      genericReconcilingDetails:
        'Menyelaraskan detail yang disebut lebih dari sekali…',
      genericFilteringSmallTalk: 'Menyaring obrolan ringan…',
      closingApplyingStructure: 'Menerapkan struktur templat…',
      closingTidyingFormatting: 'Merapikan format dan pilihan kata…',
      closingConsistencyCheck: 'Menjalankan pemeriksaan konsistensi akhir…',
      closingAlmostThere: 'Hampir selesai…',
      buildingSection: 'Menyusun bagian "{label}"…',
      pullingDetails: 'Mengambil detail kunjungan yang relevan dengan {label}…',
      organizingGroup: 'Menata bagian {label}…',
      listeningForPlaceholder: 'Menyimak {placeholder}…',
      fillingInPlaceholder: 'Mengisi {placeholder}…',
      scanningForPlaceholder: 'Memindai kunjungan untuk {placeholder}…',
    },
  },
  carePlans: {
    visitNumber: 'Kunjungan {number}',
    phaseNumber: 'Fase {number}',
    review: {
      confirmed: 'Dikonfirmasi',
      edited: 'Diedit',
      rejected: 'Ditolak',
      undo: 'Urungkan',
      edit: 'Edit',
      reject: 'Tolak',
      delete: 'Hapus',
      save: 'Simpan',
      saveChanges: 'Simpan Perubahan',
      notSet: 'Belum diatur',
      confirmAllCount: 'Konfirmasi semua {count}',
      allConfirmed: '✓ Semua dikonfirmasi',
      undoConfirmAllSection: 'Urungkan konfirmasi semua {section}',
      loadFailed:
        'Tidak dapat memuat rencana perawatan — coba muat ulang halaman.',
      updateFailed: 'Tidak dapat memperbarui rencana perawatan.',
      niceWork: 'Kerja bagus',
      addedSummary: 'Menambahkan {items}',
      updatedSummary: 'Memperbarui {items}',
      allChecklistComplete: 'Semua item daftar periksa sudah lengkap.',
      goalCountOne: '{count} tujuan',
      goalCountMany: '{count} tujuan',
      measureCountOne: '{count} ukuran',
      measureCountMany: '{count} ukuran',
      actionItemCountOne: '{count} tugas pasien',
      actionItemCountMany: '{count} tugas pasien',
      planActive: 'Rencana aktif',
      planActiveSince: 'Rencana aktif sejak {date}',
    },
    conditions: {
      title: 'Kondisi',
      onset: 'Awitan: {date}',
      recorded: 'Dicatat: {date}',
      denial: 'Penyangkalan',
      editCondition: 'Edit Kondisi',
      deleteCondition: 'Hapus Kondisi',
      deleteConfirmTitle: 'Hapus kondisi ini?',
      deleteConfirmBody:
        'Ini menghapus kondisi dari kunjungan. Penghapusan tidak dapat dibatalkan.',
    },
    goals: {
      title: 'Tujuan',
      editGoal: 'Edit Tujuan',
      addGoal: 'Tambah Tujuan',
      deleteGoal: 'Hapus Tujuan',
      deleteConfirmTitle: 'Hapus tujuan ini?',
      deleteConfirmBody:
        'Ini menghapus tujuan dari rencana. Penghapusan tidak dapat dibatalkan.',
      textPlaceholder: 'mis. Pulihkan fleksi servikal hingga 50 derajat',
      textAriaLabel: 'Teks tujuan',
      targetDate: 'Tanggal target',
      targetDateAriaLabel: 'Tanggal target tujuan',
      markDone: 'Tandai tujuan sebagai selesai',
      markPrimary: 'Tandai sebagai tujuan utama',
      primaryHint: 'Ditampilkan pertama, hanya satu per rencana',
      primary: 'Utama',
      target: 'Target',
      status: 'Status',
      done: 'Selesai',
      notDone: 'Belum Selesai',
    },
    measures: {
      title: 'Ukuran Objektif',
      editTitle: 'Edit Ukuran Objektif',
      addTitle: 'Tambah Ukuran Objektif',
      addMeasure: 'Tambah Ukuran',
      deleteMeasure: 'Hapus Ukuran',
      deleteConfirmTitle: 'Hapus ukuran ini?',
      deleteConfirmBody:
        'Ini menghapus ukuran dari rencana. Penghapusan tidak dapat dibatalkan.',
      namePlaceholder: 'Nama ukuran',
      target: 'Target',
      targetPlaceholder: 'mis. 80°',
      targetAriaLabel: 'Target ukuran',
      targetValue: 'Target {target}',
      thisVisitAriaLabel: '{label} kunjungan ini',
      trendAriaLabel: 'Tren ukuran',
    },
    actionItems: {
      title: 'Tugas Pasien',
      editTitle: 'Edit Tugas Pasien',
      addActionItem: 'Tambah Tugas Pasien',
      deleteActionItem: 'Hapus Tugas Pasien',
      deleteConfirmTitle: 'Hapus tugas pasien ini?',
      deleteConfirmBody:
        'Ini menghapus tugas dari rencana. Penghapusan tidak dapat dibatalkan.',
      textPlaceholder: 'mis. Chin tuck — 3×10 setiap hari',
      textAriaLabel: 'Teks tugas pasien',
      empty:
        'Belum ada tugas pasien — latihan akan muncul di sini setelah diresepkan.',
    },
    checklist: {
      title: 'Daftar periksa rencana perawatan',
      tierComplete: 'Lengkap',
      tierGood: 'Baik',
      tierFair: 'Cukup',
      tierWeak: 'Lemah',
      progress: '{done} dari {total}',
      setReassessFirst: 'Atur waktu penilaian ulang di Jadwal terlebih dahulu',
      confirmCarePlan: 'Konfirmasi Rencana Perawatan',
      confirmHint:
        'Konfirmasi untuk mengaktifkan rencana ini dan membawanya ke kunjungan berikutnya.',
    },
    phase: {
      title: 'Fase',
      planStarted: 'Rencana dimulai {date}',
      setPhaseAriaLabel: 'Atur fase {number}',
      editAriaLabel: 'Edit fase',
    },
    schedule: {
      title: 'Jadwal',
      editAriaLabel: 'Edit jadwal',
      visitsCount: '{count} kunjungan',
      ongoing: 'Berkelanjutan',
      defaultLabel: 'bawaan',
      earlierVisits: 'Kunjungan sebelumnya',
      laterVisits: 'Kunjungan berikutnya',
      reassessFlag: '⚑ Nilai ulang',
      visitStatusTitle: 'Kunjungan {number} · {status}',
      statusThisVisit: 'kunjungan ini',
      statusCompleted: 'selesai',
      statusUpcoming: 'akan datang',
      cadence: 'Frekuensi',
      cadenceForever: '{cadence} selamanya',
      cadenceFor: '{cadence} selama {duration} {unit}',
      unitDays: 'hari',
      unitWks: 'mgg',
      unitMo: 'bln',
      segmentFrequencyAria: 'Frekuensi segmen {number}',
      segmentPeriodUnitAria: 'Satuan periode segmen {number}',
      segmentDurationAria: 'Durasi segmen {number}',
      segmentDurationUnitAria: 'Satuan durasi segmen {number}',
      removeSegmentAria: 'Hapus segmen {number}',
      perWeek: 'per minggu',
      perMonth: 'per bulan',
      for: 'selama',
      weeks: 'minggu',
      months: 'bulan',
      days: 'hari',
      forever: 'selamanya',
      addCadence: 'Tambah Frekuensi',
      reassessAfter: 'Nilai ulang setelah',
      reassessUnitAria: 'Satuan penilaian ulang',
      visitsOption: 'kunjungan',
      reassessRequired: 'Tetapkan penilaian ulang sebelum menyimpan.',
    },
    recap: {
      title: 'Rekap pra-kunjungan',
      goals: 'Tujuan',
      noGoals: 'Belum ada tujuan dalam rencana.',
      targetDate: 'Target {date}',
      doneLastVisit: 'Selesai pada kunjungan terakhir',
      noExercises: 'Tidak ada latihan dari kunjungan terakhir.',
      addressThisVisit: 'Bahas pada kunjungan ini',
      nothingDue: 'Tidak ada yang ditandai jatuh tempo.',
      lastValue: 'terakhir {value}',
    },
    callout: {
      carePlan: 'Rencana Perawatan',
      dismiss: 'Tutup',
      draftedPrefix: 'Eluve menyusun draf',
      draftedSuffix: 'untuk kunjungan ini —',
      reviewAndTailor: 'Tinjau & sesuaikan',
      preparingPrefix: 'Eluve sedang menyiapkan',
      preparingSuffix: 'untuk kunjungan ini…',
      none: 'Tidak ada rencana perawatan yang direkomendasikan untuk kunjungan ini.',
      failed:
        'Eluve tidak dapat menyiapkan rencana perawatan untuk kunjungan ini.',
      notRequested:
        'Belum ada rencana perawatan yang dibuat untuk kunjungan ini.',
      generateHint: 'Cocokkan kunjungan ini dengan Care Library Anda',
      alreadyExists: 'Kunjungan ini sudah memiliki rencana perawatan',
      notCompleted:
        'Hanya kunjungan yang selesai dapat membuat rencana perawatan',
      noMatch:
        'Tidak ada templat rencana perawatan yang cocok dengan kunjungan ini.',
      tryAgain: 'Coba lagi',
      generate: 'Buat rencana perawatan',
    },
    chat: {
      thinking: 'Berpikir…',
      stop: 'Berhenti',
      send: 'Kirim',
      draftUpdated: 'Draf diperbarui',
      valid: 'valid',
      issueCountOne: '{count} masalah',
      issueCountMany: '{count} masalah',
      validatingWithMedplum: 'Memvalidasi dengan Medplum',
    },
    counts: {
      phaseOne: '{count} fase',
      phaseMany: '{count} fase',
      activityOne: '{count} aktivitas',
      activityMany: '{count} aktivitas',
      eventOne: '{count} kejadian',
      eventMany: '{count} kejadian',
      bandOne: '{count} rentang',
      bandMany: '{count} rentang',
    },
    tab: {
      backToNote: 'Kembali ke Catatan',
      acceptPlan: 'Terima rencana',
      acceptTailoredPlan: 'Terima rencana yang disesuaikan',
      accepted: 'Diterima',
      recommended: 'Direkomendasikan dari pertemuan ini',
      tailored: 'Disesuaikan',
      verbatimTemplate: 'Templat verbatim',
      alsoConsidered: 'Juga dipertimbangkan',
      switch: 'Ganti',
      hideFullPlan: 'Sembunyikan rencana lengkap',
      viewFullPlan: 'Lihat rencana lengkap',
      validationFailed:
        'Validasi gagal — Eluve akan memperbaiki dan menerbitkan ulang sebelum dapat diterima.',
      percentMatch: 'kecocokan {pct}%',
      phased: 'Bertahap',
      practiceLibrary: 'Pustaka praktik',
      weeksCount: '{count} minggu',
      startsOn: 'Mulai {date}',
      templateLoadFailed:
        'Kami tidak dapat memuat templat rencana yang direkomendasikan.',
      carePlanAccepted: 'Rencana perawatan diterima',
      acceptFailed: 'Gagal menerima: {error}',
      switchedTo: 'Beralih ke {title}',
      switchedDescription:
        'Rencana baru dimulai — penyesuaian sebelumnya dibuang.',
      switchFailed: 'Gagal mengganti: {error}',
      switchConfirmTitle: 'Ganti ke {title}?',
      switchConfirmBody:
        'Ini memulai rencana baru dari templat yang dipilih. Penyesuaian yang Anda buat pada draf saat ini akan dibuang.',
      keepCurrentPlan: 'Pertahankan rencana saat ini',
      switchAndDiscard: 'Ganti & buang penyesuaian',
      tailoringPlan: 'Menyesuaikan rencana',
      composerPlaceholder:
        'Beri tahu Eluve AI apa yang berbeda pada {patient}…',
      thisPatient: 'pasien ini',
      suggestionHomeBand: 'Hanya di rumah + resistance band',
      suggestionShortSessions: 'Jaga sesi di bawah 20 menit',
      suggestionGentleStart: 'Mulai perlahan — kurangi dosis awal setengahnya',
      suggestionShiftStart: 'Geser mulai ke Senin depan',
    },
    builder: {
      title: 'Plan Builder',
      subtitle:
        'Jelaskan perjalanan perawatan — simpan sebagai templat yang dapat digunakan kembali',
      medplumUnavailable: 'Medplum tidak tersedia — tidak dapat menyimpan',
      planSaved: 'Rencana disimpan',
      saveFailed: 'Gagal menyimpan: {error}',
      emptyTitle: 'Jelaskan perjalanan perawatan',
      emptyBody:
        'Plan Builder mengklasifikasikannya ke dalam bentuk rencana, menyusun strukturnya, dan beriterasi dengan Anda. Anda menyimpan saat sudah tepat — tidak ada yang disimpan sebelum itu.',
      suggestionPhased:
        'Protokol rehabilitasi ACL 4 fase: lindungi graft, pulihkan rentang gerak, bangun kembali kekuatan, kembali berolahraga — setiap fase dibatasi kriteria sebelum lanjut.',
      suggestionEpisodic:
        'Penanganan migrain kronis: baseline pemeliharaan bulanan, dengan respons terdefinisi di minggu yang sama saat serangan akut terjadi dan jalur eskalasi untuk penggunaan obat berlebihan.',
      suggestionContinuous:
        'Penanganan diabetes tipe 2 berkelanjutan: jaga HbA1c antara 6 dan 7,5%, tinjau setiap triwulan, dan eskalasikan setelah dua pembacaan berturut-turut di luar rentang.',
      attachFiles: 'Lampirkan file',
      composerPlaceholder:
        'Jelaskan perjalanan perawatan… (Enter untuk kirim, Shift+Enter untuk baris baru)',
      draftingPlan: 'Menyusun rencana',
      resolvingIssuesOne: 'Menyelesaikan {count} masalah validasi',
      resolvingIssuesMany: 'Menyelesaikan {count} masalah validasi',
      toolSearchingRecords: 'Mencari rekam medis',
      toolSearchedRecords: 'Selesai mencari rekam medis',
      toolSearchFailed: 'Pencarian rekam medis gagal',
      toolReadingRecord: 'Membaca rekam medis',
      toolReadRecord: 'Selesai membaca rekam medis',
      toolReadFailed: 'Gagal membaca rekam medis',
      toolWorking: 'Sedang bekerja',
      toolDone: 'Selesai',
      toolFailed: 'Gagal',
      attachedImageAlt: 'gambar terlampir',
      removeAttachment: 'Hapus {name}',
      attachmentFallbackName: 'lampiran',
      fileTypeUnsupported:
        '{name}: hanya gambar JPEG, PNG, GIF, atau WebP, atau dokumen PDF yang didukung.',
      pdfTooLarge: '{name}: PDF harus berukuran 10MB atau kurang.',
      imageTooLarge: '{name}: gambar harus berukuran 5MB atau kurang.',
      tooManyAttachments: 'Maksimal {max} lampiran per pesan.',
      attachmentsTooLarge:
        '{name}: ruang tidak cukup — total lampiran harus di bawah 22MB.',
    },
    preview: {
      noDraftYet: 'Belum ada draf',
      noDraftHint:
        'Jelaskan perjalanan perawatan di chat — draf akan tampil di sini saat Plan Builder membentuknya.',
      savePublishesPrefix: 'Menyimpan akan menerbitkan templat ini (status',
      savePublishesSuffix: ').',
      saving: 'Menyimpan…',
      saveAsPlanDefinition: 'Simpan sebagai Plan Definition',
      condition: 'Kondisi',
      shapingPlan: 'Plan Builder sedang membentuk rencana Anda',
      buildsLive: 'Draf terbangun di sini secara langsung saat streaming.',
      resolvingRedrafting: 'Menyelesaikan masalah validasi — menyusun ulang…',
      draftingStreaming: 'Menyusun — rencana masih dalam proses streaming.',
      validatingDraft: 'Memvalidasi draf dengan Medplum…',
      bannerResolvingOne:
        'Menyelesaikan {count} masalah validasi — menyusun ulang',
      bannerResolvingMany:
        'Menyelesaikan {count} masalah validasi — menyusun ulang',
      bannerDrafting: 'Menyusun — rencana terbangun langsung saat streaming',
      bannerValidating: 'Draf selesai — memvalidasi dengan Medplum',
      validFhir: 'FHIR valid, siap disimpan.',
      validationFailedWillFix:
        'Validasi gagal — Plan Builder akan memperbaiki dan menerbitkan ulang sebelum dapat disimpan.',
      previewFhir: 'Pratinjau FHIR',
      previewFhirDescription:
        'Bundle transaksi persis yang akan dikirim oleh Simpan — PlanDefinition beserta ActivityDefinition-nya, dikompilasi secara deterministik dari draf saat ini.',
      bundleSingle: '· PlanDefinition yang akan dibuat oleh Simpan',
      bundleMany: '· {count} sumber daya yang akan dibuat oleh Simpan',
    },
    templates: {
      pageTitle: 'Templat Rencana Perawatan',
      newPlan: 'Rencana baru',
      allCarePlans: 'Semua rencana perawatan',
      requiresMedplum:
        'Templat rencana perawatan memerlukan Medplum diaktifkan untuk organisasi ini.',
      countOne: '{count} templat',
      countMany: '{count} templat',
      loading: 'Memuat…',
      searchPlaceholder: 'Cari berdasarkan nama, kondisi, atau status…',
      loadFailed: 'Gagal memuat templat rencana perawatan: {error}',
      detailLoadFailed: 'Gagal memuat templat rencana perawatan ini: {error}',
      noMatchesPrefix: 'Tidak ada templat yang cocok dengan "',
      noMatchesSuffix: '".',
      emptyState: 'Belum ada templat rencana perawatan.',
      colTemplate: 'Templat',
      colConditions: 'Kondisi',
      colShape: 'Bentuk',
      colVersion: 'Versi',
      colStatus: 'Status',
      fhirJson: 'FHIR JSON',
      fhirJsonDescription: 'Sumber daya PlanDefinition yang tersimpan.',
      viewFhir: 'Lihat FHIR',
    },
  },
  smartBlocks: {
    featureFlagged: {
      redirected: 'Anda telah dialihkan',
    },
    amendment: {
      updateFailed: 'Gagal memperbarui amandemen',
      deleteFailed: 'Gagal menghapus amandemen',
      duplicateFailed: 'Gagal menduplikasi konten ke amandemen',
    },
    appointmentName: {
      updateFailed: 'Gagal memperbarui nama janji temu',
      updateLabel: 'Perbarui nama janji temu',
    },
    insightFeedback: {
      thanks:
        'Terima kasih atas masukan Anda! Ini membantu kami meningkatkan Eluve.',
      submitFailed: 'Gagal mengirim masukan',
    },
    inlineFeedback: {
      sendFailed: 'Gagal mengirim masukan',
      updateFailed: 'Gagal memperbarui masukan',
      updateCommentFailed: 'Gagal memperbarui komentar masukan',
    },
    customInstructions: {
      title: 'Tingkatkan Catatan',
      description:
        'Sesuaikan catatan Anda dengan memberikan panduan spesifik. Usahakan sejelas dan seringkas mungkin untuk hasil terbaik.',
      placeholder: 'Ketik instruksi Anda di sini',
      examples: 'Contoh',
      appliesToThisNote: 'Perubahan ini hanya akan berlaku untuk catatan ini.',
      regenerateNote: 'Buat Ulang Catatan',
      regenerating: 'Membuat ulang ringkasan Anda',
      regenerateFailed: 'Gagal membuat ulang ringkasan. Silakan coba lagi',
      chipRemoveParts: 'Hapus bagian tentang...',
      chipIncludeDiscussion: 'Sertakan pembahasan tentang...',
      chipMoreConcise: 'Buat catatan lebih ringkas...',
      chipMoreDetails: 'Tambahkan lebih banyak detail di bagian rencana...',
    },
    rollback: {
      title: 'Urungkan Perubahan',
      tooltip:
        'Anda masih dapat kembali ke versi sebelumnya dengan menekan tombol urungkan.',
      failed: 'Gagal kembali ke ringkasan sebelumnya',
      undo: 'Urungkan',
    },
    lifecycleStatus: {
      updated: 'Status diperbarui menjadi "{status}".',
      changedElsewhere:
        'Status pengguna ini baru saja diubah di tempat lain. Memuat ulang.',
      updateFailed: 'Status tidak dapat diperbarui.',
      changeStatusAria: 'Ubah status, saat ini {status}',
    },
    promptTemplateSelector: {
      noMatches: 'Tidak ada templat yang cocok.',
      loadingDefault: 'Memuat templat default...',
      selectTemplate: 'Pilih templat',
      searchPlaceholder: 'Cari templat prompt...',
    },
    locationSelector: {
      selectLocation: 'Pilih lokasi',
      searchPlaceholder: 'Cari lokasi...',
      noLocation: 'Tanpa lokasi',
    },
    patientSelector: {
      selectPatient: 'Pilih Pasien',
      searchPlaceholder: 'Cari berdasarkan nama, telepon, atau email',
      clearSelected: 'Hapus Pasien yang Dipilih',
      searching: 'Mencari pasien...',
      typeToSearch: 'Ketik minimal 2 karakter untuk mencari',
      patientAdded: 'Pasien {name} ditambahkan',
      addFailed: 'Gagal menambahkan pasien baru',
      createNew: 'Buat Baru',
      dob: 'Tgl lahir:',
    },
    microphoneSelector: {
      ariaLabel: 'Pemilih Sumber Audio',
      selectMicrophone: 'Pilih mikrofon',
    },
    micSettings: {
      audioSource: 'Sumber Audio',
    },
    tabNav: {
      more: 'Lainnya',
      moreTabsAria: 'Tab navigasi lainnya',
      selectTab: 'Pilih tab',
      tabs: 'Tab',
    },
    statusWidget: {
      uploading: 'Mengunggah',
      offline: 'Offline',
      uploadingOneFile: 'Mengunggah satu file',
      uploadingManyFiles: 'Mengunggah {count} file',
      keepOpen:
        'Mohon biarkan Eluve tetap terbuka dan perangkat Anda terhubung ke internet hingga proses ini selesai.',
      currentlyOffline: 'Anda sedang offline',
      offlineHint:
        'Jika Anda sedang dalam sesi, Anda dapat terus merekam, tetapi beberapa fitur seperti pembuatan catatan mungkin memerlukan koneksi.',
    },
    goToPatient: {
      tooltip: 'Lihat pasien',
    },
    dynamicArtifact: {
      emailSubject: 'Tindak lanjut dari sesi hari ini ({date})',
      emailCopied: 'Isi email disalin ke clipboard. Tempelkan ke email Anda',
      sendMailTooltip: 'Kirim email ke pasien',
      addAmendments: 'Tambahkan Amandemen',
      valueFallback: 'Nilai',
    },
    templateBuilder: {
      allBlocksMustBeValid: 'Semua blok harus valid',
      atLeastOneBlockRequired: 'Diperlukan setidaknya satu blok non-grup',
      requiredField: 'Wajib diisi',
      aboutThisTemplate: 'Tentang Templat Ini',
      export: 'Ekspor',
      exportTemplate: 'Ekspor Templat',
      jsonSchemaCopied: 'Skema JSON disalin ke clipboard',
      copyJsonSchema: 'Salin Skema JSON',
      pasteJsonSchemaPlaceholder: 'Tempel skema JSON di sini',
      nameLabel: 'Nama',
      typeLabel: 'Tipe',
      outputTypePlaceholder: 'Tipe Output',
      descriptionLabel: 'Deskripsi',
      descriptionPlaceholder:
        'Berikan deskripsi tentang artefak yang harus dihasilkan oleh templat ini.',
      variantNotes: 'Catatan Varian',
      variantNotesDescription:
        'Catatan internal untuk varian templat ini. Catatan ini terlihat oleh editor templat dan tidak akan muncul di konten yang dihasilkan.',
      variantNotesPlaceholder: 'Tambahkan catatan tentang varian ini...',
      blocks: 'Blok',
      collapseAll: 'Ciutkan Semua',
      expandAll: 'Bentangkan Semua',
      viewJson: 'Lihat JSON',
      templateJson: 'JSON Templat',
      templateJsonCopied: 'JSON templat disalin ke clipboard.',
      templateJsonCopyFailed: 'JSON templat tidak dapat disalin.',
      addBlock: 'Tambah Blok',
      groupNamePlaceholder: 'Nama grup',
      textBlockNamePlaceholder: 'Nama blok teks',
      checkboxNamePlaceholder: 'Nama kotak centang',
      expand: 'Bentangkan',
      collapse: 'Ciutkan',
      removeBlock: 'Hapus blok',
      confirmRemoveTitle: 'Apakah Anda yakin?',
      confirmRemoveDescription: 'Penghapusan blok ini tidak dapat dibatalkan.',
      remove: 'Hapus',
    },
    blockDetails: {
      fillOutBlockWith: 'Isi blok ini dengan',
      ai: 'AI',
      manual: 'Manual',
      aiOptionDescription:
        'AI akan mengisi blok ini. Pengguna dapat mengedit draf AI.',
      manualOptionDescription:
        'Blok ini akan dimulai dengan teks placeholder. Pengguna yang mengisinya.',
      required: 'Wajib diisi',
      requiredDescription:
        'AI akan selalu berusaha mengisi blok ini dan tidak akan membiarkannya kosong.',
      allowEmail: 'Izinkan pengguna mengirim blok ini melalui email',
      allowEmailDescription:
        'Jika diaktifkan, pengguna akan mendapatkan kontrol untuk mengirim isi blok ini melalui email.',
      aiInstructions: 'Instruksi AI',
      aiInstructionsPlaceholder:
        'Jelaskan apa yang harus dihasilkan AI di blok ini. Misalnya, "Tulis deskripsi singkat tentang keluhan utama pasien. Jangan gunakan kalimat lengkap."',
      checkboxes: 'Kotak Centang',
      optionPlaceholder: 'Opsi {number}',
      addOption: 'Tambah Opsi',
      placeholderTextTooltip:
        'Saat digunakan dalam mode Pencatatan Manual, teks ini akan terisi otomatis di kotak teks.',
      placeholderText: 'Teks Placeholder',
      importedDescription: 'Deskripsi Impor',
      importedDescriptionTooltip:
        'Deskripsi ini diimpor dari EHR. Deskripsi impor akan digunakan sebagai petunjuk bagi AI saat membuat catatan. Ganti dengan memberikan deskripsi Anda sendiri di atas untuk digunakan AI.',
    },
    blockPicker: {
      groupName: 'Grup',
      groupTip: 'Wadah untuk blok lain',
      textName: 'Blok teks',
      textTip: 'Teks bebas',
      checkboxName: 'Kotak centang',
      checkboxTip: 'Daftar opsi kotak centang',
      add: 'Tambah',
    },
  },
  userSettings: {
    save: 'Simpan',
    updateProfileFailed: 'Gagal memperbarui profil',
    profile: {
      dialogTitle: 'Ubah Nama Lengkap',
      editFullName: 'Ubah nama lengkap',
      firstName: 'Nama Depan',
      lastName: 'Nama Belakang',
    },
    language: {
      notesLanguage: 'Bahasa Catatan',
      notesLanguageDescription:
        'Bahasa yang digunakan dalam catatan yang dihasilkan.',
      spokenLanguage: 'Bahasa Lisan',
      spokenLanguageDescription: 'Bahasa yang digunakan selama sesi Anda.',
    },
    providerDetails: {
      placeholder:
        'Apa pun yang perlu muncul di catatan yang ditandatangani: nomor lisensi, NPI, DEA, dll.',
    },
    soundEffects: {
      updateFailed:
        'Gagal memperbarui pengaturan efek suara. Silakan coba lagi.',
      label: 'Efek Suara',
    },
    appGrants: {
      empty: 'Anda belum memasang agen apa pun.',
      granted: 'Diberikan {date}',
      unknownDate: 'tidak diketahui',
      revoke: 'Cabut',
      revoked: '{agentId} telah dicabut',
      revokeFailed: 'Gagal mencabut',
    },
    signature: {
      invalidFileExtension: 'Ekstensi file tidak valid.',
      uploadFailed: 'Kami tidak dapat mengunggah file tersebut.',
      updateFailed: 'Kami tidak dapat memperbarui tanda tangan Anda.',
      alt: 'Tanda tangan',
    },
    specialty: {
      updateFailed: 'Spesialisasi tidak dapat diperbarui.',
    },
    templates: {
      updateFailed: 'Gagal memperbarui templat default',
      loading: 'Memuat templat...',
      select: 'Pilih Templat',
    },
  },
  insightsSettings: {
    customCharts: {
      title: 'Rekam Medis Kustom',
      description: 'Tempelkan data rekam medis → Buat insight melalui API',
      placeholder: 'Tempelkan array JSON berisi data rekam medis',
      invalidSchema: 'Skema tidak valid',
      invalidJsonSyntax: 'Sintaksis JSON tidak valid',
      jsonParseError: 'Kesalahan penguraian JSON: {error}',
      processFailed: 'Gagal memproses JSON',
      validJson: 'JSON valid, siap untuk dibuat',
      generating: 'Menghasilkan...',
      generate: 'Buat Insight',
    },
  },
  careLibrary: {
    page: {
      eyebrow: 'Pustaka',
      loadError: 'Terjadi kesalahan saat memuat Pustaka Perawatan.',
      medplumRequired:
        'Pustaka Perawatan memerlukan Medplum yang diaktifkan untuk organisasi ini.',
      loadingOfferings: 'Memuat layanan…',
    },
    browse: {
      allTypes: 'Semua jenis',
      offeringsCountLabel: 'layanan',
      typesCountLabel: 'jenis',
      searchPlaceholder: 'Cari layanan…',
      searchAriaLabel: 'Cari layanan',
      allOfferings: 'Semua layanan',
      typeOfferings: 'Layanan {type}',
      noMatches: 'Tidak ada layanan yang cocok dengan filter saat ini.',
    },
    rail: {
      browseByCategory: 'Jelajahi berdasarkan kategori',
      primaryFacet: 'utama',
    },
    detail: {
      backToLibrary: 'Kembali ke Pustaka Perawatan',
      loadError: 'Terjadi kesalahan saat memuat layanan ini.',
      loadingOffering: 'Memuat layanan…',
      notFound: 'Layanan tersebut tidak dapat ditemukan.',
      noClinicalCode: 'Tanpa kode klinis',
      parameters: 'Parameter',
      parametersNote:
        '· {type} · diresepkan per pasien saat penyusunan rencana',
      patientInstructions: 'Instruksi untuk pasien',
      categoriesTitle: 'Kategori',
      belongsToPrefix: 'Termasuk dalam',
      belongsToSuffix:
        'kategori — satu item dapat berada di beberapa kategori sekaligus.',
      usedInPlansTitle: 'Digunakan dalam rencana',
      usedInPlansEmpty:
        'Rencana yang merujuk ke layanan ini akan tercantum di sini, masing-masing dengan dosis yang diresepkannya, setelah katalog didukung oleh data rencana langsung.',
      reuseByReference:
        'Penggunaan ulang dilakukan melalui referensi. Mengedit entri ini akan otomatis diterapkan ke semua rencana.',
    },
  },
  microphone: {
    noAudioDetectedCompact: 'Audio tidak terdeteksi.',
    noAudioDetectedFull:
      'Audio tidak terdeteksi. Silakan pilih sumber audio lain untuk memulai.',
    permissionsDeniedTitle: 'Izin mikrofon ditolak',
    permissionsDeniedMessage:
      'Silakan aktifkan izin mikrofon di pengaturan browser Anda untuk mengaktifkan input audio.',
    noDevicesTitle: 'Perangkat mikrofon diperlukan',
    noDevicesMessage:
      'Tidak ada perangkat mikrofon yang terhubung ke sistem Anda. Silakan beri izin mikrofon atau coba lagi.',
    retryPermission: 'Coba Izin Lagi',
    permissionsRequiredTitle: 'Izin mikrofon diperlukan',
    permissionsRequiredMessage:
      'Silakan beri izin mikrofon untuk mengaktifkan input audio.',
    requestPermission: 'Minta Izin',
  },
};
